import { Injectable, ViewChild } from "@angular/core";
import { Http, Jsonp } from "@angular/http";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/forkJoin";
import "rxjs/add/operator/map";
import {
  MenuController,
  ActionSheetController,
  Nav,
  PopoverController
} from "ionic-angular";

import { AppConfig } from "../providers/appconfig";
import { WaterlevelProvider } from "../providers/waterlevel-provider";
import { WaveProvider } from "../providers/wave-provider";
import { WebServiceProvider } from "../providers/webservice-provider";
import { sprintf } from "sprintf-js";
import { DatePipe } from "@angular/common";
import "intl";
import "intl/locale-data/jsonp/en";

// import { AppConfig } from '../providers/appconfig';
/*
  Generated class for the InundationProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
// declare var Highcharts : any;
@Injectable()
export class InundationProvider {
  @ViewChild(Nav) nav: Nav;
  // organization identifier used in service request
  organizationIdentifier: string = "GMRI";
  // project identifier- used inservice request?
  projectIdentifier: string;
  // inundation monitoring locations
  monitoringLocations: any = [];
  ml_names: any = ["loading"];

  dww_locations: any = [];

  // initialization flags
  ml_metadata_loaded: boolean = false;
  drwl_loaded: boolean = false;
  loadedMLArray: any = [];
  test_display_output: any;
  chartConfig: any;
  tideChart: any;
  hiloTideData: any;
  hiloTide: any;
  waveChart: any;
  stockton_forecast: any;
  forecast_ready: boolean = false;
  forecast_read_error: boolean = false;
  forecast_read_error_text: string;
  request_error_array: any = [];

  dataGetUrls: any = [];
  dataGetNecofsUrls: any = [];

  inundProv: any;
  inundProvObserver: any;
  notReadyText: string = "loading";
  // an array of stockton forecast requests used to block requests
  // for a location which already has a request pending
  requested_stockton_forecast: any = [];

  constructor(
    public http: Http,
    public jsonp: Jsonp,
    public appConfig: AppConfig,
    public wlService: WaterlevelProvider,
    public waveService: WaveProvider,
    public webService: WebServiceProvider,
    public sanitize: DomSanitizer,
    public datePipe: DatePipe,
    public menuCtrl: MenuController,
    public actionSheetCtrl: ActionSheetController,
    public popoverCtrl: PopoverController
  ) {
    this.inundProv = Observable.create(observer => {
      this.inundProvObserver = observer;
    });

    console.log("Hello InundationProvider Provider");
  }
  inundProvUpdates() {
    return this.inundProv;
  }
  isInitialized() {
    let ret_val: boolean = false;
    if (this.monitoringLocations.length > 0) {
      ret_val = true;
    }
    return ret_val;
  }
  // formerly in app.component.ts but now used by more than one page.
  openPage(page, nav) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    // let selectModal = this.modalCtrl.create(SelectestabPage);
    // NOTE: eventually check the page here to provide different selections
    // 11/2/2017
    // If the page is the home page then don't show the menu.
    // otherwise do show the menu.
    switch (page.component) {
      case "HomePage":
        // show the page
        if (nav != undefined) {
          nav.setRoot(page.component);
        }
        break;
      case "InundationTabsPage":
        /*
        let actionSheet = this.actionSheetCtrl.create({
             title: 'Choose a beach',
             buttons: []
           });
          for ( var mlKey in this.monitoringLocations ) {
            let mlName: string = this.monitoringLocations[mlKey].monitoringlocationname;
            let mlId : string =  this.monitoringLocations[mlKey].monitoringlocationidentifier;
            let buttonML : any =
               {
                 text: mlName,
                 role: 'destructive',
                 handler: () => {
                    this.appConfig.mainMenuTriggered = true ;
                    this.appConfig.setLocationSelected( this, mlId ) ;
                    if ( nav != undefined ) {
                      nav.setRoot(page.component);
                    }
                 }
               } ;
            actionSheet.addButton( buttonML);
          }
          actionSheet.present();
          */
        // don't show this menu if the user has already made a selection
        let inundObj: any = this.getMonitoringLocation(
          this.appConfig.getLocationSelected()
        );
        if (inundObj == undefined || inundObj.stocktonForecast == undefined) {
          let popover = this.popoverCtrl.create("FilterPage", {
            filter_type: "inundation"
          });
          popover.onDidDismiss(data => {
            if (data != "cancel") {
              // once again things aren't necessarily initialized.
              this.displayStocktonForecast();
              if (nav != undefined) {
                nav.setRoot(page.component);
              }
            }
          });
          popover.present({});
        } else {
          nav.setRoot(page.component);
        }
        break;
      case "WaveTabsPage":
        nav.setRoot(page.component);
        // don't show this menu if the user has already made a selection
        if (
          this.appConfig.platform_name == undefined ||
          this.appConfig.waveDisplayedErrorMessage == true
        ) {
          let popover = this.popoverCtrl.create("FilterPage", {
            filter_type: "waves"
          });
          popover.onDidDismiss(data => {
            if (data != "cancel") {
              this.appConfig.waveDisplayedErrorMessage = false;
              this.waveService.getWaveData(false);
            }
          });
          popover.present({});
        }
        break;
      case "TideTabsPage":
        nav.setRoot(page.component);
        // don't display if a selection has already been made
        if (this.appConfig.tide_name == undefined) {
          let popover = this.popoverCtrl.create("FilterPage", {
            filter_type: "tides"
          });
          popover.onDidDismiss(data => {
            if (data != "cancel") {
              this.wlService.getWaterlevelData(false);
            }
          });
          popover.present({});
        }
        break;
      case "AssetMapPage":
        // there's nothing you need to do. or is there
        if (nav != undefined) {
          if (nav.getActive().component.name != "AssetMapPage") {
            nav.setRoot(page.component);
          }
        }
        break;
      default:
        // show main menu
        if (nav != undefined) {
          nav.setRoot(page.component);
        }
        break;
    }
  }
  displayStocktonForecast() {
    if (
      this.getMonitoringLocation(this.appConfig.getLocationSelected()) !=
      undefined
    ) {
      // this.inundationService.forecast_ready = false ;
      // this.inundObj = this.inundationService.getStocktonForecast(false);
      let everybodyReady: boolean = true;
      if (!this.isInitialized()) {
        everybodyReady = false;
        this.initializeData();
        // subscribe to the initialdata loaded event
        this.inundProvUpdates().subscribe(event_obj => {
          console.log(event_obj.name);
          if (event_obj.name == "initial_data_loaded") {
            if (
              this.wlService.isInitialized() &&
              this.waveService.isInitialized()
            ) {
              this.forecast_ready = false;
              this.getStocktonForecast(
                false,
                this.appConfig.getLocationSelected(),
                false
              );
            }
          }
        });
      }
      if (!this.waveService.isInitialized()) {
        everybodyReady = false;
        this.waveService.waveProvUpdates().subscribe(event_obj => {
          console.log(event_obj.name);
          if (event_obj.name == "initial_platform_data_loaded") {
            if (this.wlService.isInitialized() && this.isInitialized()) {
              this.forecast_ready = false;
              this.getStocktonForecast(
                false,
                this.appConfig.getLocationSelected(),
                false
              );
            }
          }
        });
      }
      if (!this.waveService.isInitialized()) {
        everybodyReady = false;
        this.wlService.tideProvUpdates().subscribe(event_obj => {
          console.log(event_obj.name);
          if (event_obj.name == "initial_station_data_loaded") {
            if (this.waveService.isInitialized() && this.isInitialized()) {
              this.forecast_ready = false;
              this.getStocktonForecast(
                false,
                this.appConfig.getLocationSelected(),
                false
              );
            }
          }
        });
      }
      if (everybodyReady) {
        this.forecast_ready = false;
        this.getStocktonForecast(
          false,
          this.appConfig.getLocationSelected(),
          false
        );
      }
    }
  }
  sortMonitoringLocations() {
    // make sure all the attributes have been parsed
    this.fillMonitoringLocationAttributeArray();
    // ye old bubble sort
    let changed: boolean = true;
    while (changed) {
      changed = false;
      for (var sKey in this.monitoringLocations) {
        let nKey: number = parseInt(sKey);
        if (nKey < this.monitoringLocations.length - 1) {
          let nKeyTwo: string = (nKey + 1).toString();
          let sortOne: number = this.monitoringLocations[sKey]
            .inundate_attributes.sort_order;
          let sortTwo: number = this.monitoringLocations[nKeyTwo]
            .inundate_attributes.sort_order;
          // replace the name sort
          // if ( this.monitoringLocations[sKey].monitoringlocationname > this.monitoringLocations[nKeyTwo].monitoringlocationname ){
          if (sortOne > sortTwo) {
            // copy this one
            let temp: any = this.monitoringLocations[sKey];
            // replace it with the next one
            this.monitoringLocations[sKey] = this.monitoringLocations[nKeyTwo];
            // and make this one the next one.
            this.monitoringLocations[nKeyTwo] = temp;
            // flag a change
            changed = true;
          }
        }
      }
    }
  }
  // The attributes coming from the cbass web service are difficult to use.
  // getMonitoringLocation parses them and puts them in an array that's easier
  // to use
  fillMonitoringLocationAttributeArray() {
    for (let sKey in this.monitoringLocations) {
      let location_name: string = this.monitoringLocations[sKey]
        .monitoringlocationidentifier;
      let inundObj: any = this.getMonitoringLocation(location_name);
    }
  }
  // seeing if a function will make the html check for peak count work.
  getPeakCount() {
    let peak_count: number = 0;
    if (this.stockton_forecast != undefined) {
      peak_count = this.stockton_forecast.peak_count;
    }
    return peak_count;
  }
  graphCenterSelectItems() {
    let items: any = this.appConfig.getSelectItems(
      this.appConfig.graph_center_choices
    );
    return items;
  }
  graphCenterSelectedItem() {
    let item: any = this.appConfig.getSelectedItem(
      this.appConfig.getCenterDatumIndex(),
      this.appConfig.graph_center_choices
    );
    return item;
  }
  isGraphCenterSelectedItem(item) {
    let selected: boolean = false;
    let sel_item: any = this.appConfig.getSelectedItem(
      this.appConfig.getCenterDatumIndex(),
      this.appConfig.graph_center_choices
    );
    if (sel_item.id == item.id) {
      selected = true;
      // console.log( "selected item id = " + sel_item.id ) ;
    }
    return selected;
  }
  locationSelectItems() {
    let items: any = [];
    let index: number = 1;
    for (var mlKey in this.monitoringLocations) {
      let mlName: string = this.monitoringLocations[mlKey]
        .monitoringlocationname;
      let mlId: string = this.monitoringLocations[mlKey]
        .monitoringlocationidentifier;
      var item = {
        id: index,
        label: mlName,
        monitoringlocationidentifier: mlId
      };
      index++;
      items.push(item);
      if (mlKey == "10000") {
        break;
      }
    }
    return items;
  }
  locationSelectedItem(monitoringlocationidentifier) {
    let ret_val: number = 1;
    for (var mlKey in this.monitoringLocations) {
      let mlId: string = this.monitoringLocations[mlKey]
        .monitoringlocationidentifier;
      if (mlId == monitoringlocationidentifier) {
        ret_val = parseInt(mlKey) + 1;
        break;
      }
    }
    return ret_val;
  }
  isLocationSelectedItem(item) {
    let ret_val: boolean = false;
    let mlIdentifier = this.appConfig.getLocationSelected();
    if (item.monitoringlocationidentifier == mlIdentifier) {
      ret_val = true;
    }
    return ret_val;
  }
  getWaveModels() {
    return this.appConfig.waveServices;
  }
  get_erddap_dww_start_date() {
    return this.appConfig.dww_start_date;
  }
  get_erddap_dww_end_date() {
    return this.appConfig.dww_end_date;
  }
  getDwwEndDateDisplay() {
    let end_date = Date.parse(this.appConfig.dww_end_date);
    // https://angular.io/docs/ts/latest/api/common/index/DatePipe-pipe.html
    let display_date = this.datePipe.transform(end_date, "EEEE, M/d h:mma");
    return display_date;
  }
  getStocktonEndDateDisplay() {
    let num_points: number = this.stockton_forecast.stocktonPointForecasts
      .length;
    let end_point: any = this.stockton_forecast.stocktonPointForecasts[
      num_points - 1
    ];
    let end_date: any = end_point.date;
    let display_date = this.datePipe.transform(end_date, "EEEE, M/d h:mma");
    return display_date;
  }
  getMinimalDateDisplay(date_in) {
    // https://angular.io/docs/ts/latest/api/common/index/DatePipe-pipe.html
    let display_date = this.datePipe.transform(date_in, "EE h:mma");
    // <br> didn't break!
    // display_date += "<br>" + this.datePipe.transform(date_in, "h:mma");
    return display_date;
  }
  // what parameters to include in the inundation chart
  get_chart_included_display_parameters() {
    // which parameters to graph.
    var parameters = [];
    var il = this.appConfig.get_interface_level();
    switch (il) {
      case 0:
        // parameters.push( 'waveHeight' );
        // parameters.push( 'wavePeriod' );
        // parameters.push( 'waveLength' );
        // parameters.push( 'etcwlsfc' );
        parameters.push("etsurgeplustide");
        parameters.push("TIDE_AUGMENTED_ETOFS_SURGE_TIDE");
        parameters.push("Rhigh");
        parameters.push("Rlow");
        break;
      case 1:
        parameters.push("waveHeight");
        parameters.push("ERDDAP_PREDICTED_WAVE_HEIGHT");
        // parameters.push( 'wavePeriod' );
        // parameters.push( 'waveLength' );
        // parameters.push( 'etcwlsfc' );
        parameters.push("elevsfc");
        parameters.push("TIDE_ETOFS_TIDE");
        parameters.push("etsrgsfc");
        parameters.push("TIDE_ETOFS_SURGE");
        parameters.push("etsurgeplustide");
        parameters.push("TIDE_AUGMENTED_ETOFS_SURGE_TIDE");
        parameters.push("Rhigh");
        parameters.push("Rlow");
        break;
      case 5:
      default:
        parameters.push("waveHeight");
        parameters.push("ERDDAP_PREDICTED_WAVE_HEIGHT");
        // parameters.push( 'obsWaveHeight' );
        // parameters.push( 'BUOY_OBS_WAVE_HEIGHT' );
        parameters.push("observed_waterLevel");
        parameters.push("TIDE_OBS_WATER_LEVEL");
        // parameters.push( 'wavePeriod' );
        // parameters.push( 'waveLength' );
        // parameters.push( 'etcwlsfc' );
        parameters.push("elevsfc");
        parameters.push("TIDE_ETOFS_TIDE");
        parameters.push("etsrgsfc");
        parameters.push("TIDE_ETOFS_SURGE");
        parameters.push("etsurgeplustide");
        parameters.push("TIDE_AUGMENTED_ETOFS_SURGE_TIDE");
        parameters.push("R2");
        parameters.push("Rhigh");
        parameters.push("Rlow");
        break;
    }
    return parameters;
  }
  // who sees what
  get_chart_display_parameters(appConfig) {
    // which parameters to graph.
    var parameters = [];
    var il = appConfig.get_interface_level();
    switch (il) {
      case 0:
        if (appConfig.defaultParemeterVisibilities["TIDE_ETOFS_TIDE"]) {
          parameters.push("TIDE_ETOFS_TIDE");
        }
        if (appConfig.defaultParemeterVisibilities["RHIGH"]) {
          parameters.push("RHIGH");
        }
        if (appConfig.defaultParemeterVisibilities["RLOW"]) {
          parameters.push("RLOW");
        }
        break;
      case 1:
        if (appConfig.defaultParemeterVisibilities["TIDE_ETOFS_TIDE"]) {
          // don't default to showing the tide for the forecaster
          // it's available but they have to click on it to see it.
          // parameters.push( 'TIDE_ETOFS_TIDE' );
        }
        if (appConfig.defaultParemeterVisibilities["RHIGH"]) {
          parameters.push("RHIGH");
        }
        if (appConfig.defaultParemeterVisibilities["RLOW"]) {
          parameters.push("RLOW");
        }
        break;
      case 5:
      default:
        if (appConfig.defaultParemeterVisibilities["TIDE_ETOFS_TIDE"]) {
          parameters.push("TIDE_ETOFS_TIDE");
        }
        if (appConfig.defaultParemeterVisibilities["TIDE_ETOFS_SURGE"]) {
          parameters.push("TIDE_ETOFS_SURGE");
        }
        if (
          appConfig.defaultParemeterVisibilities[
            "TIDE_AUGMENTED_ETOFS_SURGE_TIDE"
          ]
        ) {
          parameters.push("TIDE_AUGMENTED_ETOFS_SURGE_TIDE");
        }
        if (appConfig.defaultParemeterVisibilities["TIDE_ETOFS_SURGE_TIDE"]) {
          parameters.push("TIDE_ETOFS_SURGE_TIDE");
        }
        if (appConfig.defaultParemeterVisibilities["RHIGH"]) {
          parameters.push("RHIGH");
        }
        if (appConfig.defaultParemeterVisibilities["RLOW"]) {
          parameters.push("RLOW");
        }
        if (
          appConfig.defaultParemeterVisibilities["ERDDAP_PREDICTED_WAVE_HEIGHT"]
        ) {
          parameters.push("ERDDAP_PREDICTED_WAVE_HEIGHT");
        }
        if (appConfig.defaultParemeterVisibilities["BUOY_OBS_WAVE_HEIGHT"]) {
          parameters.push("BUOY_OBS_WAVE_HEIGHT");
        }
        if (appConfig.defaultParemeterVisibilities["TIDE_OBS_WATER_LEVEL"]) {
          parameters.push("TIDE_OBS_WATER_LEVEL");
        }
        if (appConfig.defaultParemeterVisibilities["R2"]) {
          parameters.push("R2");
        }
        break;
    }
    return parameters;
  }
  // Deep Water Wave monitoring location
  dww_monitoring_locations(json_data) {
    this.dww_locations = [];
    // accumulate the different data sets using dww_ml_key and
    // arrays
    for (var dww_ml_key in json_data.monitoringlocations) {
      let dww_ml_identifier: string =
        json_data.monitoringlocations[dww_ml_key].monitoringlocationidentifier;
      let ml_data: any = json_data.monitoringlocations[dww_ml_key];

      let dww_ml: any = {};
      dww_ml.monitoringlocationidentifier =
        ml_data.monitoringlocationidentifier;
      dww_ml.monitoringlocationname = ml_data.monitoringlocationname;
      dww_ml.monitoringlocationstartdate = ml_data.monitoringlocationstartdate;
      dww_ml.monitoringlocationdescriptiontext =
        ml_data.monitoringlocationdescriptiontext;
      dww_ml.geolocation = ml_data.geolocation;
      this.dww_locations.push(dww_ml);
    }
  }
  getDWWLocation(dwwlocation_name) {
    // get the geo location to pass
    let dww_loc: any;
    for (var dww_key in this.dww_locations) {
      dww_loc = this.dww_locations[dww_key];
      if (dww_loc.monitoringlocationidentifier == dwwlocation_name) {
        break;
      }
    }
    return dww_loc;
  }
  getWaveLocationMetadata(wave_location_id) {
    for (var tlKey in this.waveService.wave_locations) {
      if (
        this.waveService.wave_locations[tlKey].properties.name ==
        wave_location_id
      ) {
        break;
      }
    }
    return this.waveService.wave_locations[tlKey];
  }
  // replacing ProjObjectB
  // retrieve the inundation location from the name and give it a stockton forecast
  // flag if it should be redone or not
  getStocktonForecast(force_refresh, location_name, data_only) {
    if (!this.requested_stockton_forecast[location_name]) {
      // reset the flag for a bumped end date
      this.appConfig.bumpedEndDate = false;
      // check for data and load if necessary
      // get the object for this location
      let inundObj: any = this.getMonitoringLocation(location_name);
      if (inundObj != undefined && inundObj.stocktonForecast != undefined) {
        let now: any = new Date();
        let nowms: number = Date.parse(now.toString());
        let fcstms: number = Date.parse(
          inundObj.stocktonForecast.forecast_timestamp.toString()
        );
        let elapsed = nowms - fcstms;
        if (elapsed > 1 * 60 * 1000) {
          force_refresh = true;
        }
      }
      // inundObj.inundate_attributes is not defined error.
      // check both then decide if we should proceed based on if there's an
      // existing forecast or we want to redo one.
      // This I hope covers a data missing issue by
      // checking for NOT having found a number of peaks
      // and having a forecast that is flagged as ready ( ie all done).
      if (
        inundObj.stocktonForecast != undefined &&
        inundObj.stocktonForecast.peak_count < 1 &&
        this.forecast_ready == true
      ) {
        force_refresh = true;
      }
      if (
        inundObj != undefined &&
        inundObj.inundate_attributes != undefined &&
        (inundObj.stocktonForecast == undefined || force_refresh)
      ) {
        this.forecast_ready = false;
        this.forecast_read_error = false;
        this.request_error_array = [];
        this.requested_stockton_forecast[location_name] = true;
        // providing an array of urls
        // because some may have loaded ok previously
        let dataTypeLoaded: any = [];
        let necofsDataTypeLoaded: any = [];
        let dataGETs: any = [];
        let dataGetNecofs: any = [];
        // 2015-09-15T16:00:00
        var date_range = this.appConfig.getEtofsDateRange();
        var date_start = date_range["date_start"];
        var date_last = date_range["date_last"];
        var days_forward = date_range["days_forward"];
        var hours_forward = date_range["hours_forward"];
        //  var hours_forward = days_forward * 24 ;
        var date_start_iso = date_range["date_start_iso"];
        var date_end_iso = date_range["date_end_iso"];
        // buoy dates
        var date_now = new Date();
        // var datems = Date.parse(date_start).getTime();
        var buoy_date_start = this.appConfig.getStartDate();
        var datems = buoy_date_start.getTime();
        var hours_back = Math.round(
          (date_now.getTime() - datems) / (60 * 60 * 1000)
        );
        // assemble all the necessary urls to get a full set of data
        // account for some perhaps having been previously loaded.
        // this is using classes to encapsulate the data
        let estofsKey = this.wlService.getEstofsObjectKey(location_name);
        if (
          !this.wlService.estofsObjects[estofsKey].initialized ||
          force_refresh
        ) {
          let surge_location_name: string =
            inundObj.inundate_attributes.surge_location.name;
          let getEstofs = this.http
            .get(
              this.wlService.estofsObjects[estofsKey].getDataURL(
                date_start,
                hours_forward,
                surge_location_name,
                this.appConfig
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getEstofs);
          dataTypeLoaded.push("ESTOFS");
        }
        // the buoy location ex. B01 may be shared among mulitple inundation locations.
        // it's a comparison reference location
        let wave_location_name: string =
          inundObj.inundate_attributes.buoy_location;
        // use the dww location for inundations
        let dww_loc = this.getDWWLocation(
          inundObj.inundate_attributes.deep_water_wave_location
        );

        // let tideDataObject = this.wlService.getTideObject(tide_location_name, this.appConfig);
        let waveKey = this.waveService.getWaveObjectKey(
          wave_location_name,
          this.appConfig
        );
        if (
          !this.waveService.waveObjects[waveKey].initialized ||
          force_refresh
        ) {
          // first use the meta data already initialized
          // perhaps aka as getMonitoringLocationMetadata in the wave provider.
          let waveMetaData = this.getWaveLocationMetadata(wave_location_name);
          this.waveService.waveObjects[waveKey].initialize_wave_object(
            waveMetaData,
            this
          );
          // multiple data streams here
          // metadata from cbass
          let getWW3 = this.http
            .get(
              this.waveService.waveObjects[waveKey].getWW3URL(this.appConfig)
            )
            .map(res => this.result_test(res));
          dataGETs.push(getWW3);
          dataTypeLoaded.push("WW3");
          // ww3 global data
          // NOTE: not ussing dww_start_date and dww_end_date because the global doesn't have those constraints
          let ww3StartDate: string = this.appConfig
            .getStartDate()
            .toISOString();
          // now coastwatchs erddap is unpredictable so use a value gleaned from them on start up
          // as the end date.
          // let ww3EndDate: string = this.appConfig.getEndDate().toISOString();
          let ww3EndDate: string = this.appConfig.dww_global_end_date;
          var geo_array = this.appConfig.parseGeoLocation(dww_loc.geolocation);
          let dwwGlobalURL: string = this.waveService.waveObjects[
            waveKey
          ].getWW3CoastwatchGlobalDataURL(
            ww3StartDate,
            ww3EndDate,
            geo_array,
            this.appConfig
          );
          this.dataGetUrls.push(dwwGlobalURL);
          // let getGlobalDWW  = this.http.get(dwwGlobalURL).map(res => this.result_test(res));
          let getGlobalDWW = this.http
            .get(dwwGlobalURL)
            .map(res => this.result_test(res));
          dataGETs.push(getGlobalDWW);
          dataTypeLoaded.push("WW3GLOBAL");

          let getBuoyObservations = this.http
            .get(
              this.waveService.waveObjects[waveKey].getBuoyObservationURL(
                this.appConfig
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getBuoyObservations);
          dataTypeLoaded.push("WAVE_OBSERVATIONS");
          // check for availability of wave data
          let erdDataTypes: any = [
            "significant_wave_height",
            "significant_wave_height_qc",
            "dominant_wave_period",
            "dominant_wave_period_qc"
          ];
          let return_erddap: any = this.waveService.neracoosErddap.getDatasetID(
            this.appConfig,
            this.waveService.waveObjects[waveKey].ml_name,
            erdDataTypes
          );
          if (return_erddap["datasetID"] != null) {
            let getErdWaveObsURL: string = this.waveService.waveObjects[
              waveKey
            ].getERDDAPObservationURL(
              this.appConfig,
              erdDataTypes,
              return_erddap
            );
            this.dataGetUrls.push(getErdWaveObsURL);
            let getBuoyErdWaveObservations = this.jsonp
              .request(getErdWaveObsURL)
              .map(res => this.result_jsonp_test(res));
            // 9/11/2017 get erddap to use jsonp.
            dataGETs.push(getBuoyErdWaveObservations);
            dataTypeLoaded.push("ERDDAP_WAVE_OBSERVATIONS");
          }

          let getNECOFSWavePredictions = this.http
            .get(this.waveService.waveObjects[waveKey].getNECOFSWaveURL())
            .map(res => this.result_test(res));
          dataGetNecofs.push(getNECOFSWavePredictions);
          necofsDataTypeLoaded.push("NECOFS_WAVE_PREDICTIONS");
          let getNECOFSWaveLengthPredictions = this.http
            .get(this.waveService.waveObjects[waveKey].getNECOFSWaveLengthURL())
            .map(res => this.result_test(res));
          dataGetNecofs.push(getNECOFSWaveLengthPredictions);
          necofsDataTypeLoaded.push("NECOFS_WAVE_LENGTH_PREDICTIONS");
        }
        // the tide location ex. 8423898 may be shared among mulitple inundation locations.
        // it's a comparison reference location
        let tide_location_name: string =
          inundObj.inundate_attributes.tide_location;
        // let tideDataObject = this.wlService.getTideObject(tide_location_name, this.appConfig);
        let tideKey = this.wlService.getTideObjectKey(
          tide_location_name,
          this.appConfig
        );
        if (!this.wlService.tideObjects[tideKey].initialized || force_refresh) {
          // first use the meta data already initialized
          let tlMetaData = this.wlService.getTideLocationMetadata(
            tide_location_name
          );
          this.wlService.tideObjects[tideKey].initialize_tide_object(
            tlMetaData,
            this.appConfig
          );
          // tideDataObject.initialize_tide_object( tlMetaData, this.appConfig )
          // multiple data streams here
          // metadata from cbass
          let getTide = this.http
            .get(
              this.wlService.tideObjects[tideKey].getDataURL(
                date_start,
                hours_forward,
                tide_location_name,
                this.appConfig
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getTide);
          dataTypeLoaded.push("TIDE");
          // prediction data from tides and currents
          let getPredictions = this.http
            .get(
              this.wlService.tideObjects[tideKey].getPredictionsURL(
                this.appConfig,
                6,
                "lst_ldt"
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getPredictions);
          dataTypeLoaded.push("TIDE_PREDICTIONS");
          // High/low prediction data from tides and currents
          // NOTE: GMT so I can manipulate the date easily
          let getHiloPredictions = this.http
            .get(
              this.wlService.tideObjects[tideKey].getPredictionsURL(
                this.appConfig,
                "hilo",
                "gmt"
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getHiloPredictions);
          dataTypeLoaded.push("HILO_TIDE_PREDICTIONS");
          // observed water level from tides and currents
          let getObs = this.http
            .get(
              this.wlService.tideObjects[tideKey].getWaterLevelURL(
                this.appConfig
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getObs);
          dataTypeLoaded.push("TIDE_OBSERVED");
          // ESTOFS data for the same location as this tide station
          let getESTOFS = this.http
            .get(
              this.wlService.tideObjects[tideKey].getEstofsURL(this.appConfig)
            )
            .map(res => this.result_test(res));
          dataGETs.push(getESTOFS);
          dataTypeLoaded.push("TIDE_LOCATION_ESTOFS");
          // NECOFS data for the same location as this tide station
          // necofs data isn't used in the stockton equation because it's too unreliably available
          let getNECOFS = this.http
            .get(
              this.wlService.tideObjects[tideKey].getNecofsURL(this.appConfig)
            )
            .map(res => this.result_test(res));
          dataGetNecofs.push(getNECOFS);
          necofsDataTypeLoaded.push("TIDE_LOCATION_NECOFS");
        }
        // THIS ISN'T NECESSARY FOR THE STOCKTON FORECAST!
        let usgsTidalDataObject = this.wlService.getUSGSTidalObject(
          location_name
        );
        if (!usgsTidalDataObject.initialized || force_refresh) {
          let usgslocation_name: string =
            inundObj.inundate_attributes.usgstidal_location;
          let getUSGSTidal = this.http
            .get(
              usgsTidalDataObject.getDataURL(
                date_start,
                hours_forward,
                usgslocation_name,
                this.appConfig
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getUSGSTidal);
          dataTypeLoaded.push("USGSTIDAL");
        }
        let bioWW3DataObject = this.webService.getBioWW3Object(location_name);
        if (!bioWW3DataObject.initialized || force_refresh) {
          let biolocation_name: string =
            inundObj.inundate_attributes.bioww3_location.name;
          let data_type_name: string =
            inundObj.inundate_attributes.bioww3_location.data_type_name;
          let getBioWW3 = this.http
            .get(
              bioWW3DataObject.getDataURL(
                date_start,
                hours_forward,
                biolocation_name,
                data_type_name,
                this.appConfig
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getBioWW3);
          dataTypeLoaded.push("BIOWW3");
        }
        let buoyDataObject = this.webService.getBuoyObject(location_name);
        if (!buoyDataObject.initialized || force_refresh) {
          let bdlocation_name: string =
            inundObj.inundate_attributes.buoy_location;
          let getBuoy = this.http
            .get(
              buoyDataObject.getDataURL(
                date_start,
                hours_back,
                bdlocation_name,
                this.appConfig
              )
            )
            .map(res => this.result_test(res));
          dataGETs.push(getBuoy);
          dataTypeLoaded.push("BUOY");
        }
        let dwwDataObject = this.waveService.getDWWObject(location_name);
        if (!dwwDataObject.initialized || force_refresh) {
          let dwwlocation_name: any =
            inundObj.inundate_attributes.deep_water_wave_location;
          // Erddap ww3 data
          // get the geo location to pass
          let dww_loc: any;
          for (var dww_key in this.dww_locations) {
            dww_loc = this.dww_locations[dww_key];
            if (dww_loc.monitoringlocationidentifier == dwwlocation_name) {
              break;
            }
          }
          var geo_array = this.appConfig.parseGeoLocation(dww_loc.geolocation);
          let dwwURL: string = dwwDataObject.getDataURL(
            this.appConfig.dww_start_date,
            this.appConfig.dww_end_date,
            geo_array,
            this.appConfig
          );
          let getDWW = this.http.get(dwwURL).map(res => this.result_test(res));
          dataGETs.push(getDWW);
          dataTypeLoaded.push("DWW");
          // NECOFS data
          // Wave height
          let dwwNECOFSWavePredictionsURL: string = dwwDataObject.getNECOFSWaveURL(
            geo_array
          );
          let getDWWNECOFSWavePredictions = this.http
            .get(dwwNECOFSWavePredictionsURL)
            .map(res => this.result_test(res));
          dataGetNecofs.push(getDWWNECOFSWavePredictions);
          necofsDataTypeLoaded.push("NECOFS_DWW_WAVE_PREDICTIONS");
          // Wave Length
          let dwwNECOFSWavelengthPredictionsURL: string = dwwDataObject.getNECOFSWaveLengthURL(
            geo_array
          );
          let getDWWNECOFSWavelengthPredictions = this.http
            .get(dwwNECOFSWavelengthPredictionsURL)
            .map(res => this.result_test(res));
          dataGetNecofs.push(getDWWNECOFSWavelengthPredictions);
          necofsDataTypeLoaded.push("NECOFS_DWW_WAVE_LENGTH_PREDICTIONS");
        }
        // use a separate observable for necofs
        if (dataGetNecofs.length > 0) {
          Observable.forkJoin(dataGetNecofs).subscribe(
            results =>
              this.forecastDataReady(
                "necofs_data",
                results,
                location_name,
                data_only,
                dataTypeLoaded,
                necofsDataTypeLoaded
              ),
            error =>
              this.forecastDataError(
                "NECOFS Data Failed to Load",
                error,
                location_name
              ),
            () =>
              this.forecastDataComplete("NECOFS Data Complete", location_name)
          );
        } else {
          // the data was already loaded
          // do nothing. It's taken care of by the other dataGets stuff.
        }
        // have the http get's go get the data.
        // this is still subject to problems. I'm utilizing the dataTypeLoaded array
        // to keep track of the url's that are being accessed. But  what if this is hit
        // again before the observable has come back? It won't happen now but
        // it's a model that needs work to be safe.
        if (dataGETs.length > 0) {
          Observable.forkJoin(dataGETs).subscribe(
            results =>
              this.forecastDataReady(
                "stable_data",
                results,
                location_name,
                data_only,
                dataTypeLoaded,
                necofsDataTypeLoaded
              ),
            error =>
              this.forecastDataError(
                "Stable Data Failed to Load",
                error,
                location_name
              ),
            () =>
              this.forecastDataComplete("Stable Data Complete", location_name)
          );
        } else {
          // the data was already loaded
          let tideKey = this.wlService.getTideObjectKey(
            tide_location_name,
            this.appConfig
          );
          let wave_location_name: string =
            inundObj.inundate_attributes.buoy_location;
          let waveKey = this.waveService.getWaveObjectKey(
            wave_location_name,
            this.appConfig
          );
          let number_of_peaks_to_save: number = 8;
          let stocktonForecast: any = new stockton_forecast(
            location_name,
            inundObj,
            this.wlService.estofsObjects[estofsKey],
            this.wlService.tideObjects[tideKey],
            bioWW3DataObject,
            buoyDataObject,
            dwwDataObject,
            this.appConfig,
            this.waveService.waveObjects[waveKey].waveGlobalPredictionData,
            number_of_peaks_to_save,
            this.waveService.waveObjects[
              waveKey
            ].erddapWaveHeightObservationData
          );
          this.setMonitoringLocationStocktonForecast(
            location_name,
            stocktonForecast
          );
          let newInundObj: any = this.createStocktonForecast(
            location_name,
            "feet",
            this.appConfig.wave_model_selected
          );
          let test_html: string = newInundObj.stocktonForecast.testDisplay();
          test_html += newInundObj.stocktonForecast.testDisplayTwo();
          this.test_display_output = this.sanitize.bypassSecurityTrustHtml(
            test_html
          );
          let ret_array: any = this.createStocktonChart(
            location_name,
            this.appConfig.wave_model_selected
          );
          this.chartConfig = ret_array["chartConfig"];
          this.stockton_forecast = newInundObj.stocktonForecast;
          // redraw the helper graphs
          let usgsTidalDataObject = this.wlService.getUSGSTidalObject(
            location_name
          );
          // tide chart
          let tide_array: any = this.wlService.tideObjects[tideKey].drawChart(
            this.appConfig
          );
          this.tideChart = tide_array["chartConfig"];
          this.hiloTideData = this.wlService.tideObjects[
            tideKey
          ].hiloTidePredictionData;
          this.hiloTide = this.wlService.tideObjects[tideKey].getHiloTideData(
            this.appConfig,
            true
          );
          // wave chart
          let wave_array: any = this.waveService.waveObjects[
            waveKey
          ].drawWaveChart(this.appConfig);
          this.waveChart = wave_array["chartConfig"];
          this.forecast_ready = true;
        }
      } else {
        let inundObj: any = this.getMonitoringLocation(location_name);
        if (data_only) {
          // send out an event object
          let event_obj_init_data: any = {
            name: "location_loaded",
            location_name: location_name
          };
          this.inundProvObserver.next(event_obj_init_data);
        }
        if (
          inundObj != undefined &&
          inundObj.stocktonForecast != undefined &&
          !data_only
        ) {
          this.stockton_forecast = inundObj.stocktonForecast;
          let ret_array: any = this.createStocktonChart(
            location_name,
            this.appConfig.wave_model_selected
          );
          this.chartConfig = ret_array["chartConfig"];
          // redraw the graphs
          let tide_location_name: string =
            inundObj.inundate_attributes.tide_location;
          // let tideDataObject = this.wlService.getTideObject(tide_location_name, this.appConfig);
          let tideKey = this.wlService.getTideObjectKey(
            tide_location_name,
            this.appConfig
          );
          let wave_location_name: string =
            inundObj.inundate_attributes.buoy_location;
          let waveKey = this.waveService.getWaveObjectKey(
            wave_location_name,
            this.appConfig
          );
          let usgsTidalDataObject = this.wlService.getUSGSTidalObject(
            location_name
          );
          // tide chart
          let tide_array: any = this.wlService.tideObjects[tideKey].drawChart(
            this.appConfig
          );
          this.tideChart = tide_array["chartConfig"];
          this.hiloTideData = this.wlService.tideObjects[
            tideKey
          ].hiloTidePredictionData;
          this.hiloTide = this.wlService.tideObjects[tideKey].getHiloTideData(
            this.appConfig,
            true
          );
          // wave chart
          let wave_array: any = this.waveService.waveObjects[
            waveKey
          ].drawWaveChart(this.appConfig);
          this.waveChart = wave_array["chartConfig"];
          this.forecast_ready = true;
        }
      }
      return inundObj;
    }
  }
  result_test(res) {
    let result: any;
    if (this.IsJsonString(res._body)) {
      result = res.json();
    } else {
      // Don't try to handle the errors
      // this would pass the error on to the next step
      // forecasetDataReady and I'm not ready to handle that.
      let result_err: any = {
        error: "failed json parsing",
        url: res.url,
        content: res._body
      };
      this.request_error_array.push(result_err);
      // this throws an error and we end up in forecastDataError.
      result = res.json();
    }
    return result;
  }
  result_jsonp_test(res) {
    let result: any;
    if (typeof res._body === "object") {
      result = res.json();
    } else {
      // Don't try to handle the errors
      // this would pass the error on to the next step
      // forecasetDataReady and I'm not ready to handle that.
      let result_err: any = {
        error: "failed json parsing",
        url: res.url,
        content: res._body
      };
      this.request_error_array.push(result_err);
      // this throws an error and we end up in forecastDataError.
      result = res.json();
    }
    return result;
  }
  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  createStocktonForecast(location_name, units, wave_model_name) {
    this.notReadyText = "creating forecast...";
    let inundObj: any = this.getMonitoringLocation(location_name);
    let ret_val: any = inundObj.stocktonForecast.createForecasts(
      units,
      true,
      true,
      wave_model_name
    );
    if (location_name == "MILE_STRETCH_ROAD") {
      var test = "test";
    }
    let found_problem: boolean = false;
    for (var fe_key in ret_val["failedExplainations"]) {
      var return_explanation = ret_val["failedExplainations"][fe_key];
      switch (fe_key) {
        case "ESTOFS":
          this.notReadyText += return_explanation;
          inundObj.stocktonForecast.forecast_completed = false;
          found_problem = true;
          break;
        case "PEAK_COUNT":
          this.notReadyText += return_explanation;
          inundObj.stocktonForecast.forecast_completed = false;
          found_problem = true;
          break;
        default:
          this.notReadyText += return_explanation;
          break;
      }
    }
    if (!found_problem) {
      inundObj.stocktonForecast.forecast_completed = true;
    }
    inundObj.stocktonForecast.decodeAssessmentLevel();
    // it's crazy but this object is different now so put it back
    // also this.forecast_ready here doesn't seem to reflect back up the way it should
    // So I set it elsewhere.  The whole forecast_ready flag thing seems suspect.
    this.forecast_ready = true;
    this.setMonitoringLocationStocktonForecast(
      location_name,
      inundObj.stocktonForecast
    );
    var stop = "debug";
    return inundObj;
  }
  createStocktonChart(location_name, wave_model_name) {
    let inundObj: any = this.getMonitoringLocation(location_name);
    // which parameters to graph.
    var parameters = this.get_chart_included_display_parameters();
    let ret_array: any = inundObj.stocktonForecast.stocktonChartConfig2(
      parameters,
      this,
      wave_model_name
    );
    var stop = "debug";
    return ret_array;
  }
  // this handles the subscription to two multi http querys
  // on is for everything but necofs and the other is for necofs.
  // necofs on occasion just times out so go ahead without it.
  forecastDataReady(
    data_queried,
    results,
    location_name,
    data_only,
    stable_array,
    necofs_array
  ) {
    // this.forecast_read_error = false ;
    // allow new requests
    let data_errors: boolean = false;
    this.requested_stockton_forecast[location_name] = false;
    // keep a status
    let dataLoadingText: string = "Loading data from...";
    let dataLoading: any = [];

    if (data_queried == "stable_data") {
      for (var dKey in stable_array) {
        dataLoading[dKey] = true;
      }
    }

    if (data_queried == "necofs_data") {
      for (var dKey in necofs_array) {
        dataLoading[dKey] = true;
      }
    }
    // get the object for this location
    let inundObj: any = this.getMonitoringLocation(location_name);
    let estofsKey = this.wlService.getEstofsObjectKey(location_name);
    let tide_location_name: string = inundObj.inundate_attributes.tide_location;
    // let tideDataObject = this.wlService.getTideObject(tide_location_name, this.appConfig);
    let tideKey = this.wlService.getTideObjectKey(
      tide_location_name,
      this.appConfig
    );
    let wave_location_name: string = inundObj.inundate_attributes.buoy_location;
    let waveKey = this.waveService.getWaveObjectKey(
      wave_location_name,
      this.appConfig
    );
    let usgsTidalDataObject = this.wlService.getUSGSTidalObject(location_name);
    let bioWW3DataObject = this.webService.getBioWW3Object(location_name);
    let buoyDataObject = this.webService.getBuoyObject(location_name);
    let dwwDataObject = this.waveService.getDWWObject(location_name);
    // depending on the same order that they were pushed into the arrays.
    if (data_queried == "stable_data") {
      for (var dKey in stable_array) {
        switch (stable_array[dKey]) {
          case "ESTOFS":
            this.wlService.estofsObjects[estofsKey].surge_data = results[dKey];
            this.wlService.estofsObjects[estofsKey].initialized = true;
            break;
          case "TIDE":
            this.wlService.tideObjects[tideKey].tide_data = results[dKey];
            this.wlService.tideObjects[tideKey].initialized = true;
            break;
          case "TIDE_PREDICTIONS":
            this.wlService.tideObjects[tideKey].tidePredictionData =
              results[dKey];
            break;
          case "HILO_TIDE_PREDICTIONS":
            this.wlService.tideObjects[tideKey].hiloTidePredictionData =
              results[dKey];
            break;
          case "TIDE_OBSERVED":
            this.wlService.tideObjects[tideKey].waterLevelData = results[dKey];
            break;
          case "TIDE_LOCATION_ESTOFS":
            this.wlService.tideObjects[tideKey].surgeData = results[dKey];
            break;
          case "USGSTIDAL":
            usgsTidalDataObject.usgstidal_data = results[dKey];
            usgsTidalDataObject.initialized = true;
            break;
          case "BIOWW3":
            bioWW3DataObject.bioww3_data = results[dKey];
            bioWW3DataObject.initialized = true;
            break;
          case "BUOY":
            buoyDataObject.buoy_data = results[dKey];
            buoyDataObject.initialized = true;
            break;
          case "DWW":
            dwwDataObject.dww_data = results[dKey];
            dwwDataObject.initialized = true;
            break;
          case "WW3":
            // so this is how you might handle errors explicity
            // however it's a little late in the game to implement this
            // so let forecastDataError handle the errors.
            if (results[dKey].error != undefined) {
              data_errors = true;
            } else {
              this.waveService.waveObjects[waveKey].wavePredictionData =
                results[dKey];
            }
            break;
          case "WAVE_OBSERVATIONS":
            this.waveService.waveObjects[waveKey].waveHeightObservationData =
              results[dKey];
            break;
          case "ERDDAP_WAVE_OBSERVATIONS":
            this.waveService.waveObjects[
              waveKey
            ].erddapWaveHeightObservationData = results[dKey];
            break;
          case "WW3GLOBAL":
            this.waveService.waveObjects[waveKey].waveGlobalPredictionData =
              results[dKey];
            let max_ts: number = 0;
            var time_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
              this.waveService.waveObjects[waveKey].waveGlobalPredictionData
                .table.columnNames,
              "time"
            );
            for (var dww_key in this.waveService.waveObjects[waveKey]
              .waveGlobalPredictionData.table.rows) {
              let resultdatetext: any = this.waveService.waveObjects[waveKey]
                .waveGlobalPredictionData.table.rows[dww_key][time_index];
              // Date.parse("2016-03-31T13:00:00Z")
              var rdt_temp =
                resultdatetext.substr(0, 4) +
                "/" +
                resultdatetext.substr(5, 2) +
                "/" +
                resultdatetext.substr(8, 2) +
                " " +
                resultdatetext.substr(11, 8) +
                " GMT";
              var resultdatems = Date.parse(rdt_temp);
              if (resultdatems > max_ts) {
                max_ts = resultdatems;
              }
            }
            if (max_ts > 0) {
              this.appConfig.bumpEndDate(max_ts);
            }
            break;
          default:
            break;
        }
        dataLoading[dKey] = false;
        dataLoadingText = "Loading Status:";
        for (var dlKey in dataLoading) {
          if (dataLoading[dlKey]) {
            dataLoadingText += " " + dlKey + "-loaded";
          } else {
            dataLoadingText += " " + dlKey + "-loading";
          }
        }
        this.notReadyText = dataLoadingText;
      }
    }
    if (data_queried == "necofs_data") {
      // depending on the same order that they were pushed into the arrys.
      for (var dKey in necofs_array) {
        switch (necofs_array[dKey]) {
          case "TIDE_LOCATION_NECOFS":
            // REMEMBER THIS NEEDS TO BE ON IT's OWN!
            this.wlService.tideObjects[tideKey].necofs_data = results[dKey];
            break;
          case "NECOFS_WAVE_PREDICTIONS":
            // REMEMBER THIS NEEDS TO BE ON IT's OWN!
            this.waveService.waveObjects[waveKey].necofs_wave_data =
              results[dKey];
            let resultdatetext: string = this.waveService.waveObjects[waveKey]
              .necofs_wave_data.end_time;
            var rdt_temp =
              resultdatetext.substr(0, 4) +
              "/" +
              resultdatetext.substr(5, 2) +
              "/" +
              resultdatetext.substr(8, 2) +
              " " +
              resultdatetext.substr(11, 8) +
              " GMT";
            var resultdatems = Date.parse(rdt_temp);
            this.appConfig.bumpEndDate(resultdatems);
            break;
          case "NECOFS_WAVE_LENGTH_PREDICTIONS":
            // REMEMBER THIS NEEDS TO BE ON IT's OWN!
            this.waveService.waveObjects[waveKey].necofs_wavelength_data =
              results[dKey];
            break;
          case "NECOFS_DWW_WAVE_PREDICTIONS":
            dwwDataObject.necofs_wave_data = results[dKey];
            break;
          case "NECOFS_DWW_WAVE_LENGTH_PREDICTIONS":
            dwwDataObject.necofs_wavelength_data = results[dKey];
            break;
          default:
            break;
        }
      }
    }
    this.loadedMLArray[location_name] = true;
    // NECOFS data is usually a little slower than the rest.
    // For Mile Stretch Beach this can mean that second time around
    // the initialized flag is false. But the surge_data is there
    // They are both set at the same time! I can't figure it out!
    if (
      (this.wlService.estofsObjects[estofsKey].initialized ||
        this.wlService.estofsObjects[estofsKey].surge_data != undefined) &&
      buoyDataObject.initialized &&
      dwwDataObject.initialized &&
      this.wlService.tideObjects[tideKey].initialized &&
      !data_errors
    ) {
      let number_of_peaks_to_save: number = 8;
      let stocktonForecast: any = new stockton_forecast(
        location_name,
        inundObj,
        this.wlService.estofsObjects[estofsKey],
        this.wlService.tideObjects[tideKey],
        this.wlService.estofsObjects[estofsKey].initialized,
        buoyDataObject,
        dwwDataObject,
        this.appConfig,
        this.waveService.waveObjects[waveKey].waveGlobalPredictionData,
        number_of_peaks_to_save,
        this.waveService.waveObjects[waveKey].erddapWaveHeightObservationData
      );
      this.setMonitoringLocationStocktonForecast(
        location_name,
        stocktonForecast
      );
      let newInundObj: any = this.createStocktonForecast(
        location_name,
        "feet",
        this.appConfig.wave_model_selected
      );
      let test_html: string = newInundObj.stocktonForecast.testDisplay();
      test_html += newInundObj.stocktonForecast.testDisplayTwo();
      this.test_display_output = this.sanitize.bypassSecurityTrustHtml(
        test_html
      );
      // this.test_display_output = test_html ;
      if (data_only) {
        // send out an event object
        let event_obj_init_data: any = {
          name: "location_loaded",
          location_name: location_name,
          data_queried: data_queried
        };
        this.inundProvObserver.next(event_obj_init_data);
      } else {
        // if The wave model the user selected isn't necofs and the data coming in isn't necofs
        // then go ahead and draw a new chart
        // if  the wave model the user selected was necofs and the data coming in is necofs
        // then also go ahead and draw a new chart
        // if the user hand not selected necofs then there's no reason to re draw the chart
        // when necofs data becomes available.
        // This logic is tripping me up when NECOFS is down. It stops a newly selected location
        // from drawing using the default forecast of ww3 global
        //  (this.appConfig.wave_model_selected == 'NECOFS' && data_queried == 'necofs_data') ) {
        // give up and allow for multiple redraws. First the non necofs then the necofs.
        if (
          (this.appConfig.wave_model_selected != "NECOFS" &&
            data_queried != "necofs_data") ||
          this.appConfig.wave_model_selected == "NECOFS"
        ) {
          let ret_array: any = this.createStocktonChart(
            location_name,
            this.appConfig.wave_model_selected
          );
          this.chartConfig = ret_array["chartConfig"];
          this.stockton_forecast = newInundObj.stocktonForecast;
        }
        // tide chart
        let tide_array: any = this.wlService.tideObjects[tideKey].drawChart(
          this.appConfig
        );
        this.tideChart = tide_array["chartConfig"];
        this.hiloTideData = this.wlService.tideObjects[
          tideKey
        ].hiloTidePredictionData;
        this.hiloTide = this.wlService.tideObjects[tideKey].getHiloTideData(
          this.appConfig,
          true
        );
        // wave chart
        let wave_array: any = this.waveService.waveObjects[
          waveKey
        ].drawWaveChart(this.appConfig);
        this.waveChart = wave_array["chartConfig"];
        this.forecast_ready = true;
        if (!this.appConfig.isLocationUserSelected()) {
          this.menuCtrl.open();
        }
      }
    }
  }
  forecastDataError(data_queried, error, location_name) {
    // allow new requests
    this.requested_stockton_forecast[location_name] = false;
    this.forecast_read_error = true;
    this.forecast_read_error_text =
      'Data is unavailable from at least one Service. Error Messages was "' +
      error +
      '"';
    // for ( let eKey in this.request_error_array ) {
    //   this.forecast_read_error_text += "URL=" + this.request_error_array[eKey].url ;
    //   this.forecast_read_error_text += "Return=" + this.request_error_array[eKey].content ;
    // }
    // Errors happen when the erddap date range becomes stale
    // Try this here. It could also be handled by those that subscribe""
    // to the inundProvObserver but lets see how this goes.
    this.waveService.initializeData(true);
    // send out an event object
    let event_obj_data: any = {
      name: "forecast_data_error",
      data_loaded: "no",
      error_msg: "what have you done!?",
      error: error,
      data_queried: data_queried
    };
    if (this.inundProvObserver != undefined) {
      this.inundProvObserver.next(event_obj_data);
    }
  }
  forecastDataComplete(data_queried, location_name) {
    // allow new requests
    this.requested_stockton_forecast[location_name] = false;
    // send out an event object
    let event_obj_data: any = {
      name: "forecast_data_complete",
      data_loaded: "maybe",
      data_queried: data_queried
    };
    if (this.inundProvObserver != undefined) {
      this.inundProvObserver.next(event_obj_data);
    }
  }
  isForecastReady() {
    let ready: any = false;
    if (
      this.forecast_ready &&
      this.stockton_forecast != undefined &&
      this.stockton_forecast.peak_count > 1
    ) {
      ready = true;
    }
    return ready;
  }
  isForecastChosen() {
    let ready: any = false;
    if (this.stockton_forecast != undefined) {
      ready = true;
    }
    return ready;
  }
  notReadyExplaination() {
    let return_text = "loading...";
    // give the forecast time to finish.
    if (this.forecast_ready) {
      return_text = this.notReadyText;
    }
    if (this.forecast_read_error) {
      return_text += this.forecast_read_error_text;
    }
    return return_text;
  }

  initializeData() {
    if (!this.ml_metadata_loaded || !this.drwl_loaded) {
      this.appConfig.configUpdates().subscribe(event_obj => {
        console.log(event_obj.name);
        if (event_obj.name == "updated_preference") {
          switch (event_obj.preference) {
            case "DATUM":
              // try setting the center here
              this.appConfig.initializeCenterDatumIndex();
              break;
            case "LOCATION_SELECTED":
              this.appConfig.setLocationSelected(this, event_obj.value);
              this.menuCtrl.close();
              break;
            case "TAB_SELECTED":
              /*
              if ( this.appConfig.getTabSelected() == "graph" ) {
                this.pageTabs.select(1);
                this.tabsIndex = 1 ;
              }*/
              break;
          }
        }
      });
      let inunURL: string = this.appConfig.getIndundationLocationURL();
      let dwwURL: string = this.appConfig.getDeepWaterWaveURL();

      let inundationLocation = this.http
        .get(inunURL)
        .map(res => this.result_test(res));
      let deepWaterWave = this.http
        .get(dwwURL)
        .map(res => this.result_test(res));

      Observable.forkJoin([inundationLocation, deepWaterWave]).subscribe(
        results => {
          // Inundation Locations
          this.projectIdentifier = results[0].projectidentifier;
          this.monitoringLocations = results[0].monitoringlocations;
          this.sortMonitoringLocations();
          // date range water level
          if (this.appConfig.debug_dww) {
            console.log(
              "Deep Water Wave Response Date data retuned:" + results[1].data
            );
          }

          // deep water wave locations
          this.dww_monitoring_locations(results[1]);
          // dwwLocationRetrieval();
          // send out an event object
          let event_obj_init_data: any = {
            name: "initial_data_loaded",
            data_loaded: "yes"
          };
          this.inundProvObserver.next(event_obj_init_data);
          // Testing below
          // let initialInundation : any = this.getMonitoringLocation();
          // this.getStocktonForecast(false, this.dww_start_date, this.dww_end_date);
          // return ( initialInundation ) ;
          if (!this.appConfig.isLocationUserSelected()) {
            // this.menuCtrl.open();
          } else {
            //this.inundationTabsPage.setOpenTab();
            // send out an event object
            // let event_obj: any = { name: "set_opening_tab", set_opening_tab: "yes" }
            // this.inundProvObserver.next(event_obj);
          }
        },
        error => console.log(error)
      );
    }
  }
  setMonitoringLocationStocktonForecast(mlIdentifier, stocktonForecast) {
    for (var inundation_ml_key in this.monitoringLocations) {
      var inundation_ml_identifier = this.monitoringLocations[inundation_ml_key]
        .monitoringlocationidentifier;
      if (inundation_ml_identifier == mlIdentifier) {
        this.monitoringLocations[
          inundation_ml_key
        ].stocktonForecast = stocktonForecast;
        break;
      }
    }
  }
  getMonitoringLocation(location_name) {
    // first check for the initial data being loaded.
    let found_selected: boolean = false;
    if (this.monitoringLocations != undefined) {
      for (var inundation_ml_key in this.monitoringLocations) {
        var inundation_ml_identifier = this.monitoringLocations[
          inundation_ml_key
        ].monitoringlocationidentifier;
        if (inundation_ml_identifier == location_name) {
          found_selected = true;
          break;
        }
      }
    }
    if (found_selected) {
      // then check for attributes having been decoded from their cbass data structure.
      // the attributes need to be decoded from their generic descriptions
      if (
        this.monitoringLocations[inundation_ml_key].inundate_attributes ==
        undefined
      ) {
        let json_data: any = this.monitoringLocations[inundation_ml_key];
        let inundate_attributes: any = {};
        // var obj_text = JSON.stringify(json_data, null, 4)
        // hyper.log("inundate_attribution data received:" + obj_text);
        // hyper.log("inundate_attribution ml is :" + this.monitoringlocationidentifier);
        // walk the attributes
        for (var attr_key in json_data.attributes) {
          // walk the fields in each attribute
          // the number of fields in this attribute
          // There's never more than 1, at least now.
          let attribute_count: number =
            json_data.attributes[attr_key].fields.length;
          for (var field_index in json_data.attributes[attr_key].fields) {
            var field_keys = Object.keys(
              json_data.attributes[attr_key].fields[field_index]
            );
            // the number of fields in this attribute
            let field_count: number = field_keys.length;
            for (var field_key in field_keys) {
              var multi_field_obj_name;
              // look to get fieldfloat from either fieldfloat or fieldfloat_0
              // so we know what data type this is.
              // even though there is a datatype_name specified!!!
              var field_name = field_keys[field_key];
              var us_index = field_name.indexOf("_");
              if (us_index != -1) {
                var field_name_type = field_name.substring(0, us_index);
              } else {
                var field_name_type = field_name;
              }
              var ro_text =
                "json_data.attributes[" +
                attr_key +
                "].fields[" +
                field_index +
                "]['" +
                field_name +
                "']";
              var random_object = eval(ro_text);

              switch (field_name_type) {
                case "fieldchar32":
                case "fieldchar512":
                  if (random_object["standard_name"] != undefined) {
                    let standard_name: string = random_object["standard_name"];
                    let data_value: any = random_object["data_value"];
                    // this.surge_location = 'CAMP_ELLIS_1'
                    if (field_count > 1) {
                      if (parseInt(field_key) == 0) {
                        // create an object and
                        // use the first thing as the object's name
                        multi_field_obj_name = standard_name;
                        inundate_attributes[multi_field_obj_name] = {};
                        inundate_attributes[
                          multi_field_obj_name
                        ].name = data_value;
                      }
                      // save the value
                      inundate_attributes[multi_field_obj_name][
                        standard_name
                      ] = data_value;
                    } else {
                      // it's a single paremeter keep it simple
                      inundate_attributes[standard_name] = data_value;
                    }
                  }
                  break;
                case "fieldfloat":
                  if (random_object["standard_name"] != undefined) {
                    let standard_name: string = random_object["standard_name"];
                    let data_value: any = random_object["data_value"];
                    // this.slope = 0.1111
                    if (field_count > 1) {
                      if (parseInt(field_key) == 0) {
                        // create an object and
                        // use the first thing as the object's name
                        multi_field_obj_name = standard_name;
                        inundate_attributes[multi_field_obj_name] = {};
                        inundate_attributes[
                          multi_field_obj_name
                        ].name = multi_field_obj_name;
                      }
                      // save the value
                      inundate_attributes[multi_field_obj_name][
                        standard_name
                      ] = parseFloat(data_value);
                    } else {
                      // it's a single paremeter keep it simple
                      inundate_attributes[standard_name] = parseFloat(
                        data_value
                      );
                    }
                  }
                  break;
              }
            }
          }
        }
        this.monitoringLocations[
          inundation_ml_key
        ].inundate_attributes = inundate_attributes;
      }
      return this.monitoringLocations[inundation_ml_key];
    } else {
      return null;
    }
  }
}
class stockton_forecast {
  hasData: boolean = false;
  name: string;
  inundObj: any;
  appConfig: any;
  stocktonPointForecasts: any = [];
  monitoringlocationname: string;
  monitoringlocationidentifier: string;
  dune_crest_object: any;
  dune_base_object: any;
  surgeObject: any;
  bioww3Object: any;
  buoyObject: any;
  tideObject: any;
  dwwObject: any;
  necofs_wave_data: any;
  necofs_wavelength_data: any;
  waveGlobalPredictionData: any;
  inundation_images: any = [];
  over_wash_images: any = [];
  erosion_images: any = [];
  impact_images: any = [];
  alarm_md: any = [];
  alarm_hm_ampm: any = [];
  slope: number;
  inundation: any = [];
  alarm_timestamp: any = [];
  over_wash: any = [];
  erosion: any = [];
  peak_values: any = [];
  peak_values_timestamp: any = [];
  peak_values_md: any = [];
  peak_values_hm_ampm: any = [];
  peak_count: number = 0;
  peak_points: any = [];
  peak_order: any = [];
  relativeOffset: number;
  relativeTo: string;
  dune_crest_datum: string;
  dune_crest: number;
  dune_base_datum: string;
  dune_base: number;
  tideMLLW: number;
  tideMSL: number;
  tideMHHW: number;
  tideMHW: number;
  tideNAVD88: number;
  surge_location: any;
  surge_datum: string;
  bioww3_location: any;
  bioww3_datatypename: string;
  buoy_location: any;
  tide_location: any;
  units: string;
  max_value: number;
  max_waterlevel: number;
  min_waterlevel: number;
  dt_format: string;
  pwl_percent: number;
  pwl_percent_prompt: string;
  pwl_percent_increase_prompt: string;
  etofs_tide_percent_increase_prompt: string;
  etofs_tide_percent: number;
  etofs_surge_percent: number;
  etofs_surge_percent_increase_prompt: string;
  wave_percent_increase_prompt: string;
  display_dune_crest: string;
  display_dune_base: string;
  display_MSL: string;
  display_NAVD88: string;
  display_MLLW: string;
  display_MHHW: string;
  forecast_complete_html_table: string;
  max_sf_point: any;
  sf_forecast_ready: boolean = false;
  forecast_timestamp: any;
  necofs_wave_data_found: boolean = false;
  ww3_bedford_wave_data_found: boolean = false;
  forecast_completed: boolean = false;
  number_of_peaks_to_save: number = 8;
  erddapWaveHeightObservationData: any;

  constructor(
    name: string,
    inundObj: any,
    estofsDataObject: any,
    tideDataObject: any,
    bioWW3DataObject: any,
    buoyDataObject: any,
    dwwDataObject: any,
    appConfig: any,
    waveGlobalPredictionData: any,
    number_of_peaks_to_save: number,
    erddapWaveObservation: any
  ) {
    this.name = name;
    this.inundObj = inundObj;
    this.monitoringlocationname = name;
    this.monitoringlocationidentifier = inundObj.monitoringlocationidentifier;
    this.dune_crest_object = inundObj.inundate_attributes.dune_crest;
    this.dune_base_object = inundObj.inundate_attributes.dune_base;
    this.appConfig = appConfig;
    this.number_of_peaks_to_save = number_of_peaks_to_save;

    this.surgeObject = estofsDataObject;
    this.bioww3Object = bioWW3DataObject;
    this.buoyObject = buoyDataObject;
    this.tideObject = tideDataObject;
    this.dwwObject = dwwDataObject;
    this.necofs_wave_data = dwwDataObject.necofs_wave_data;
    this.necofs_wavelength_data = dwwDataObject.necofs_wavelength_data;
    this.waveGlobalPredictionData = waveGlobalPredictionData;
    this.erddapWaveHeightObservationData = erddapWaveObservation;

    this.slope = parseFloat(inundObj.inundate_attributes.slope);

    // initialize the images to green for good.
    for (var i = 0; i < 8; i++) {
      this.inundation_images[i] = "img/symbols/noimpact.png";
      this.over_wash_images[i] = "img/symbols/noimpact.png";
      this.erosion_images[i] = "img/symbols/noimpact.png";
      this.impact_images[i] = "img/symbols/noimpact.png";
    }
    this.forecast_timestamp = new Date();
  }

  // find the maximum_forecast
  // it's it's own function so I can change how it works
  getMaxSFPoint() {
    var max_surge_tide = 0;
    var max_sf_key = -1;
    // loop through the points
    for (var sf_key in this.stocktonPointForecasts) {
      var sp = this.stocktonPointForecasts[sf_key];
      for (var sp_key in sp) {
        // elevsfc surface ocean surface elevation relative to geoid (tide) [m]
        // elevsfc: "-1.29414"
        // etcwlsfc: "-1.24568"	storm surge and tide
        // etsrgsfc: "0.0484595"	storm surge
        // location: "POINT(43.4462525546 -70.3251926151)"
        // reading_time: "2015-09-29 17:00:00-04"
        if (sp_key == "etcwlsfc") {
          var this_surge_tide = parseFloat(sp[sp_key]);
          if (this_surge_tide > max_surge_tide) {
            max_surge_tide = this_surge_tide;
            max_sf_key = parseInt(sf_key);
          }
        }
      }
    }
    let max_point: any = this.stocktonPointForecasts[max_sf_key];
    return max_point;
  }
  // graph legend augmentation method
  legendAugmentation() {
    var test_output = "<table>";
    test_output +=
      "<tr><td>Predicted Wave Height</td><td>&nbsp;</td><td>" +
      this.inundObj.inundate_attributes.deep_water_wave_location +
      "</td></tr>";
    test_output +=
      "<tr><td>OWH</td><td>&nbsp;</td><td>" +
      this.inundObj.inundate_attributes.buoy_location +
      "</td></tr>";
    test_output +=
      "<tr><td>Surge Location Name</td><td>&nbsp;</td><td>" +
      this.inundObj.inundate_attributes.surge_location.name +
      "</td></tr>";
    test_output += "<table>";
    return test_output;
  }
  // test display method
  testDisplay() {
    var test_output = "<table>";
    // test_output += "<tr><td>Organization Identifier</td><td>" + this.inundObj.organizationidentifier +
    //                   "</td></tr>";
    // test_output += "<tr><td>Project Identifier</td><td>" + this.inundObj.projectidentifier +
    //                   "</td></tr>";
    test_output +=
      "<tr><td>Inundation Identifier</td><td>" +
      this.inundObj.monitoringlocationidentifier +
      "</td></tr>";
    test_output +=
      "<tr><td>Name</td><td>" +
      this.inundObj.monitoringlocationname +
      "</td></tr>";
    test_output +=
      "<tr><td>Description</td><td>" +
      this.inundObj.monitoringlocationdescriptiontext +
      "</td></tr>";
    test_output +=
      "<tr><td>Location</td><td>" + this.inundObj.geolocation + "</td></tr>";
    if (!this.hasData) {
      test_output +=
        "<tr><td>Attribution</td><td>Not a Surge Location</td></tr>";
    } else {
      // surge location metadata
      for (var po_key in this.inundObj.surge_objects) {
        if (this.inundObj.surge_objects[po_key].isSurgeLocation) {
          // test_output += '<tr><td>Attributions at Index</td><td>' + po_key + "</td></tr>";
          test_output +=
            "<tr><td>Surge Location Name</td><td>" +
            this.inundObj.surge_objects[0].surge_location.name +
            "</td></tr>";
          test_output +=
            "<tr><td>Surge datum</td><td>" +
            this.inundObj.surge_objects[0].surge_location.datum +
            "</td></tr>";
          test_output +=
            "<tr><td>Deep Water Wave Location Name</td><td>" +
            this.inundObj.dww_objects[0].deep_water_wave_location +
            "</td></tr>";
          if (this.inundObj.surge_objects[po_key].surge_data != undefined) {
            var surge_data = this.inundObj.surge_objects[po_key].surge_data;
          }
          test_output +=
            "<tr><td>Buoy Name</td><td>" +
            this.buoyObject.buoy_location +
            "</td></tr>";
        } else {
          test_output +=
            "<tr><td>Surge Index</td><td>Not a Surge Location</td></tr>";
        }
      }
      // tide location metadata
      for (var po_key in this.inundObj.tide_objects) {
        if (this.inundObj.tide_objects[po_key].isTideLocation) {
          // test_output += '<tr><td>Attributions at Index</td><td>' + po_key + "</td></tr>";
          var ml = this.inundObj.tide_objects[po_key].tide_data
            .monitoringlocations;
          for (var sa_key in ml) {
            // This is getting only the things I'm expecting of this right now
            // fields for mllw, msl etc.
            test_output +=
              "<tr><td>" +
              ml[sa_key].monitoringlocationdescriptiontext +
              " - " +
              ml[sa_key].monitoringlocationidentifier +
              " at <a href='http://tidesandcurrents.noaa.gov/stationhome.html?id=" +
              ml[sa_key].monitoringlocationidentifier +
              "' target='new'>" +
              ml[sa_key].monitoringlocationname +
              "</a></td></tr>";
            for (var attr_key in ml[sa_key].attributes) {
              test_output +=
                "<tr><td>" +
                ml[sa_key].attributes[attr_key].fields[0].fieldfloat_0
                  .standard_name +
                "</td><td>" +
                ml[sa_key].attributes[attr_key].fields[0].fieldfloat_0
                  .data_value +
                "</td></tr>";
            }
          }
          if (this.inundObj.tide_objects[po_key].tide_data != undefined) {
            var tide_data = this.inundObj.tide_objects[po_key].tide_data;
          }
        } else {
          test_output +=
            "<tr><td>Tide Index</td><td>Not a Tide Location</td></tr>";
        }
      }
    }
    test_output += "<tr><td>---------</td><td>------------</td></tr>";
    test_output +=
      '<tr><td colspan="2">elevsfc - surface ocean surface elevation relative to geoid (tide) [m]</td></tr>';
    test_output +=
      '<tr><td colspan="2">etsrgsfc - surface extra tropical storm surge [m]</td></tr>';
    test_output +=
      '<tr><td colspan="2">etcwlsfc - surface extra tropical storm surge combined surge and tide [m]</td></tr>';
    test_output +=
      '<tr><td colspan="2">R2 = (0.35 * Bf (H0L0)raised to the 1/2 + [H0L0(0.563Bf squared + .004)] to the 1/2 all divided by 2)</td></tr>';
    test_output +=
      '<tr><td colspan="2">Bf - Before shore Beach slope</td></tr>';
    test_output += '<tr><td colspan="2">H0 - Deep water wave height</td></tr>';
    test_output += '<tr><td colspan="2">L0 - Deep water wave length</td></tr>';
    test_output +=
      '<tr><td colspan="2">Rhigh = etcwlsfc (surge_and_tide) + R2</td></tr>';
    test_output +=
      '<tr><td colspan="2">waveSetup = 0.35 * beachSlope * sqrt(H0L0)</td></tr>';
    test_output += "<table>";
    return test_output;
  }
  testDisplayTwo() {
    var test_output3 = "<table>";
    // loop through the points
    for (var sf_key in this.stocktonPointForecasts) {
      test_output3 += '<tr><td colspan="2">' + sf_key + "</td></tr>";
      var sp = this.stocktonPointForecasts[sf_key];
      for (var sp_key in sp) {
        switch (sp_key) {
          case "etsurgeplustide":
          case "etcwlsfc":
          case "elevsfc":
          case "etsrgsfc":
          case "etofs_debug_data":
            break;
          case "waveHeight":
          case "waveLength":
          case "Rhigh":
          case "Rlow":
          case "max_value":
          case "max_waterlevel":
            var meters = this.appConfig.gmriUnits.conv_feet_to_meters(
              sp[sp_key]
            );
            var dt_format = this.appConfig.dataTypeFormatString("water_level");
            var meters_formatted = sprintf(dt_format, meters);
            test_output3 +=
              "<tr><td>" +
              sp_key +
              "</td><td>" +
              sp[sp_key] +
              " ft, (" +
              meters_formatted +
              " m)</td></tr>";
            break;
          default:
            test_output3 +=
              "<tr><td>" + sp_key + "</td><td>" + sp[sp_key] + "</td></tr>";
            break;
        }
      }
      test_output3 += sp.etofs_debug_data;
    }
    test_output3 += "</table>";
    return test_output3;
  }
  // select an icon or whatever we end up doing.
  decodeAssessmentLevel() {
    for (var i = 0; i < this.number_of_peaks_to_save; i++) {
      if (this.inundation[i]) {
        this.inundation_images[i] = "img/symbols/inundation.png";
        this.impact_images[i] = "img/symbols/inundation.png";
        this.alarm_hm_ampm[i] = this.appConfig.formatAMPM(
          this.alarm_timestamp[i]
        );
        var month = this.alarm_timestamp[i].getMonth() + 1;
        this.alarm_md[i] = month + "/" + this.alarm_timestamp[i].getDate();
      }
      if (this.over_wash[i]) {
        this.over_wash_images[i] = "img/symbols/overwash.png";
        this.impact_images[i] = "img/symbols/overwash.png";
        this.alarm_hm_ampm[i] = this.appConfig.formatAMPM(
          this.alarm_timestamp[i]
        );
        var month = this.alarm_timestamp[i].getMonth() + 1;
        this.alarm_md[i] = month + "/" + this.alarm_timestamp[i].getDate();
      }
      if (this.erosion[i]) {
        this.erosion_images[i] = "img/symbols/erosion.png";
        this.impact_images[i] = "img/symbols/erosion.png";
        this.alarm_hm_ampm[i] = this.appConfig.formatAMPM(
          this.alarm_timestamp[i]
        );
        var month = this.alarm_timestamp[i].getMonth() + 1;
        this.alarm_md[i] = month + "/" + this.alarm_timestamp[i].getDate();
      }
    }
  }
  // create forecasts method
  // use_erddap_dww is getting ww3 data from erddap vs the bio web service
  // check_for_necofs_first will substitute Necofs wave and wavelength data if it's available.
  createForecasts(
    units,
    use_erddap_dww,
    check_for_necofs_first,
    wave_model_name
  ) {
    var startDate = this.appConfig.getStartDate();
    // var hours_forward = this.appConfig.getDaysForward() * 24 ;
    var hours_forward = this.appConfig.getHoursForward();
    var relative_to = this.appConfig.getGraphCenter();
    var tide_surge_variability = this.appConfig.getTSVariability();
    var wave_percent = this.appConfig.getWavePercent();
    this.name = this.inundObj.monitoringlocationname;
    var surge_data;
    var bioww3_data_type_name;
    var bioww2_data;
    var buoy_data;
    var beachSlope;
    var waveHeight;
    var wavePeriod;
    var waveLength;
    var obsWaveHeight;
    var obsWavePeriod;
    var obsWaveLength;
    var elevsfc; // surface ocean surface elevation relative to geoid (tide) [m] "
    var etsrgsfc; // surface extra tropical storm surge [m] "
    var etcwlsfc; // surface extra tropical storm surge combined surge and tide [m] "
    var surge;
    var duneCrest;
    var duneBase;
    let failedExplaination: any = [];
    let validPointsFound: any = [];

    this.relativeOffset = 0; // What's zero on the chart. Usually MSL
    this.relativeTo = relative_to;
    this.dune_crest_datum = this.dune_crest_object.datum;
    this.dune_base_datum = this.dune_base_object.datum;
    this.dune_crest = this.dune_crest_object.dune_crest;
    this.dune_base = this.dune_base_object.dune_base;
    this.tideMLLW = null;
    this.tideMSL = null;
    this.tideMHHW = null;
    this.tideMHW = null;
    this.tideNAVD88 = null;
    this.surge_location = this.inundObj.inundate_attributes.surge_location.name;
    this.surge_datum = this.inundObj.inundate_attributes.surge_location.datum;
    this.units = units;
    this.max_value = 0;
    this.max_waterlevel = 0;
    this.min_waterlevel = 0;
    this.inundation = [];
    this.over_wash = [];
    this.erosion = [];
    this.alarm_timestamp = [];
    this.peak_values = [];
    this.peak_values_timestamp = [];

    this.dt_format = this.appConfig.dataTypeFormatString("water_level");
    this.pwl_percent = this.appConfig.getPWLPercent();
    this.pwl_percent_prompt = this.appConfig.getPWLPrompt();
    this.pwl_percent_increase_prompt = "";
    this.wave_percent_increase_prompt = "";
    this.etofs_tide_percent = this.appConfig.getETOFSTIDEPercent();
    this.etofs_tide_percent_increase_prompt = "";
    this.etofs_surge_percent = this.appConfig.getETOFSSURGEPercent();
    this.etofs_surge_percent_increase_prompt = "";
    this.peak_count = 0;
    var current_peak = 0;
    var current_peak_rlow = 0;
    var last_peak = 0;
    var last_peak_rlow = 0;
    let current_peak_point: any;
    var current_peak_date;
    var last_peak_date;
    var peak_finding_status = "beginning";

    // initialize the flags to false for good.
    for (var i = 0; i < this.number_of_peaks_to_save; i++) {
      this.inundation[i] = false;
      this.over_wash[i] = false;
      this.erosion[i] = false;
    }

    if (this.surgeObject.surge_data != undefined) {
      var surge_data = this.surgeObject.surge_data;
    }
    if (this.bioww3Object.bioww3_data != undefined) {
      var bioww3_data = this.bioww3Object.bioww3_data;
    }
    if (this.buoyObject.buoy_data != undefined) {
      var buoy_data = this.buoyObject.buoy_data;
    }
    if (this.dwwObject.dww_data != undefined) {
      var dww_data = this.dwwObject.dww_data;
    }

    var test_output = "<table>";
    // tide location metadata
    if (this.tideObject != undefined) {
      // test_output += '<tr><td>Attributions at Index</td><td>' + po_key + "</td></tr>";
      var ml = this.tideObject.tide_data.monitoringlocations;
      for (var sa_key in ml) {
        // This is getting only the things I'm expecting of this right now
        // fields for mllw, msl etc.
        // test_output += "<tr><td>" + ml[sa_key].monitoringlocationdescriptiontext +
        //         " - " + ml[sa_key].monitoringlocationidentifier + " at " +
        //         ml[sa_key].monitoringlocationname + "</td></tr>";
        for (var attr_key in ml[sa_key].attributes) {
          //  test_output += "<tr><td>" + ml[sa_key].attributes[attr_key].fields[0].fieldfloat_0.standard_name + "</td><td>" +
          //         ml[sa_key].attributes[attr_key].fields[0].fieldfloat_0.data_value + "</td></tr>";
          switch (
            ml[sa_key].attributes[attr_key].fields[0].fieldfloat_0.standard_name
          ) {
            case "MLLW":
              this.tideMLLW =
                ml[sa_key].attributes[
                  attr_key
                ].fields[0].fieldfloat_0.data_value;
              break;
            case "MSL":
              this.tideMSL =
                ml[sa_key].attributes[
                  attr_key
                ].fields[0].fieldfloat_0.data_value;
              break;
            case "MHHW":
              this.tideMHHW =
                ml[sa_key].attributes[
                  attr_key
                ].fields[0].fieldfloat_0.data_value;
              break;
            case "MHW":
              this.tideMHW =
                ml[sa_key].attributes[
                  attr_key
                ].fields[0].fieldfloat_0.data_value;
              break;
            case "NAVD88":
              this.tideNAVD88 =
                ml[sa_key].attributes[
                  attr_key
                ].fields[0].fieldfloat_0.data_value;
              break;
          }
        }
      }
      if (this.tideObject.tide_data != undefined) {
        var tide_data = this.tideObject.tide_data;
      }
    } else {
      test_output += "<tr><td>Tide Index</td><td>Not a Tide Location</td></tr>";
    }
    switch (this.relativeTo) {
      case "MSL":
        this.relativeOffset = this.tideMSL;
        break;
      case "MLLW":
        this.relativeOffset = this.tideMLLW;
        break;
      case "MHHW":
        this.relativeOffset = this.tideMHHW;
        break;
      case "NAVD88":
        this.relativeOffset = this.tideNAVD88;
        break;
      default:
        break;
    }
    switch (this.dune_crest_datum) {
      case "NAVD88":
        this.dune_crest += this.tideNAVD88;
        break;
      case "MSL":
        this.dune_crest += this.tideMSL;
        break;
      case "MLLW":
        this.dune_crest += this.tideMLLW;
        break;
      default:
        break;
    }
    switch (this.dune_base_datum) {
      case "NAVD88":
        this.dune_base += this.tideNAVD88;
        break;
      case "MSL":
        this.dune_base += this.tideMSL;
        break;
      case "MLLW":
        this.dune_base += this.tideMLLW;
        break;
      default:
        break;
    }
    var dt_format = this.appConfig.dataTypeFormatString("water_level");
    this.dune_crest = parseFloat(sprintf(dt_format, this.dune_crest));
    this.dune_base = parseFloat(sprintf(dt_format, this.dune_base));
    var pointDate = new Date(startDate);
    var dateOffset = 60 * 60 * 1000 * 1; // 1 hour between points
    let necofs_point_count: number = 0;
    validPointsFound["ESTOFS"] = false;
    for (var hour = 0; hour < hours_forward; hour++) {
      waveHeight = -9999.9;
      wavePeriod = -9999.9;
      waveLength = -9999.9;
      obsWaveHeight = -9999.9;
      obsWavePeriod = -9999.9;
      obsWaveLength = -9999.9;
      elevsfc = -9999.9;
      etsrgsfc = -9999.9;
      etcwlsfc = -9999.9;

      pointDate.setTime(pointDate.getTime() + dateOffset);
      // surge data
      // this surge_datum is somewhat academic at the moment.
      // but I can see where in the future knowing the datum of a
      // data source like this would be useful.
      var water_level_offset = this.tideMSL;
      switch (this.surge_datum) {
        case "MSL":
          water_level_offset = this.tideMSL;
          break;
        case "MLLW":
          water_level_offset = this.tideMLLW;
          break;
        case "NAVD88":
          water_level_offset = this.tideNAVD88;
          break;
      }
      var etofs_debug_data = "";

      for (var sd_key in surge_data.data) {
        var resultdatetext = surge_data.data[sd_key].reading_time;
        // adding two zeros seems to do the trick
        // Date.parse("2015-09-30 07:00:00-0400")
        resultdatetext += "00";
        // works in safari BUT Date(resultdatetext) doesn't make it past typescript!
        // var safari_date_text = Date(resultdatetext) ;
        // var safari_date = new Date(safari_date_text) ;
        // var resultdatems = safari_date.getTime();
        // change 2017-06-01 00:00:00-0400
        // to 2017/06/01 00:00:00-0400
        // wave data seems to have a T in it? So skip that character everywhere.
        // "2017/06/05T01:00:00Z"
        // var rdt_temp = resultdatetext.replace(/-/g, '/').replace(/[a-z]+/gi, ' ');
        var rdt_temp =
          resultdatetext.substr(0, 4) +
          "/" +
          resultdatetext.substr(5, 2) +
          "/" +
          resultdatetext.substr(8, 2) +
          " " +
          resultdatetext.substr(11);
        var resultdatems = Date.parse(rdt_temp);
        var pointdatems = Date.parse(pointDate.toString());
        // 5-11-2017 How did this ever work?
        // var rdtime = resultdatems.getTime();
        // var pdtime = pointdatems.getTime();
        // if ( rdtime == pdtime ) {
        if (resultdatems == pointdatems) {
          // flag if any results are valid
          if (this.monitoringlocationidentifier == "MILE_STRETCH_ROAD") {
            var test = "test";
          }
          if (
            surge_data.data[sd_key].elevsfc < 9999.99 &&
            surge_data.data[sd_key].etsrgsfc < 9999.99 &&
            surge_data.data[sd_key].etcwlsfc < 9999.99
          ) {
            validPointsFound["ESTOFS"] = true;
          }
          switch (units) {
            case "feet":
              elevsfc = this.appConfig.gmriUnits.conv_meters_to_feet(
                surge_data.data[sd_key].elevsfc
              );
              etsrgsfc = this.appConfig.gmriUnits.conv_meters_to_feet(
                surge_data.data[sd_key].etsrgsfc
              );
              etcwlsfc = this.appConfig.gmriUnits.conv_meters_to_feet(
                surge_data.data[sd_key].etcwlsfc
              );
              elevsfc += water_level_offset;
              // etsrgsfc  += water_level_offset ; surge has no offset.
              etcwlsfc += water_level_offset;
              // create a debug string to keep track of how these were calculated
              var dt_format = this.appConfig.dataTypeFormatString(
                "water_level"
              );
              var meters = this.appConfig.gmriUnits.conv_feet_to_meters(
                elevsfc
              ); // already offset.
              var m_display = sprintf(" (" + dt_format + " m)", meters);
              var ft_display = sprintf(dt_format + " ft", elevsfc);
              var elevsfc_display = sprintf(
                dt_format,
                surge_data.data[sd_key].elevsfc
              );
              etofs_debug_data =
                "<tr><td>tide</td><td>" +
                ft_display +
                m_display +
                " (elevsfc " +
                elevsfc_display +
                " m water level offset " +
                water_level_offset +
                " f)</td></tr>";

              var meters = this.appConfig.gmriUnits.conv_feet_to_meters(
                etsrgsfc
              ); // already offset.
              var m_display = sprintf(" (" + dt_format + " m)", meters);
              var ft_display = sprintf(dt_format + " ft", etsrgsfc);
              var etsrgsfc_display = sprintf(
                dt_format,
                surge_data.data[sd_key].etsrgsfc
              );
              etofs_debug_data +=
                "<tr><td>Surge</td><td>" +
                ft_display +
                m_display +
                " (etsrgsfc " +
                etsrgsfc_display +
                " m water level offset " +
                water_level_offset +
                " f)</td></tr>";

              var meters = this.appConfig.gmriUnits.conv_feet_to_meters(
                etcwlsfc
              ); // already offset.
              var m_display = sprintf(" (" + dt_format + " m)", meters);
              var ft_display = sprintf(dt_format + " ft", etcwlsfc);
              var etcwlsfc_display = sprintf(
                dt_format,
                surge_data.data[sd_key].etcwlsfc
              );
              etofs_debug_data +=
                "<tr><td>Surge + Tide</td><td>" +
                ft_display +
                m_display +
                " (etcwlsfc " +
                etcwlsfc_display +
                " m " +
                this.surge_datum +
                "-" +
                water_level_offset +
                " f)</td></tr>";
              break;
            case "meters":
            default:
              elevsfc = surge_data.data[sd_key].elevsfc;
              etsrgsfc = surge_data.data[sd_key].etsrgsfc;
              etcwlsfc = surge_data.data[sd_key].etcwlsfc;
              elevsfc += this.appConfig.gmriUnits.conv_feet_to_meters(
                water_level_offset
              );
              etsrgsfc += this.appConfig.gmriUnits.conv_feet_to_meters(
                water_level_offset
              );
              etcwlsfc += this.appConfig.gmriUnits.conv_feet_to_meters(
                water_level_offset
              );
              etofs_debug_data = "Debug Data not formatted for display yet";
              break;
          }
          // save a prompt for the chart
          if (this.pwl_percent != 0) {
            if (this.pwl_percent > 0) {
              this.pwl_percent_increase_prompt = "(+" + this.pwl_percent + "%)";
            } else {
              this.pwl_percent_increase_prompt = "(" + this.pwl_percent + "%)";
            }
            // apply the relative offset before calculating the percentage value
            var offset_percentage = etcwlsfc - this.relativeOffset;
            etcwlsfc = etcwlsfc + offset_percentage * (this.pwl_percent / 100);
            etcwlsfc = parseFloat(sprintf(this.dt_format, etcwlsfc));
          }
          // save a prompt for the chart
          if (this.etofs_tide_percent != 0) {
            if (this.etofs_tide_percent > 0) {
              this.etofs_tide_percent_increase_prompt =
                "(+" + this.etofs_tide_percent + "%)";
            } else {
              this.etofs_tide_percent_increase_prompt =
                "(" + this.etofs_tide_percent + "%)";
            }
            var offset_percentage = elevsfc - this.relativeOffset;
            elevsfc =
              elevsfc + offset_percentage * (this.etofs_tide_percent / 100);
            elevsfc = parseFloat(sprintf(this.dt_format, elevsfc));
          }
          // save a prompt for the chart
          if (this.etofs_surge_percent != 0) {
            if (this.etofs_surge_percent > 0) {
              this.etofs_surge_percent_increase_prompt =
                "(+" + this.etofs_surge_percent + "%)";
            } else {
              this.etofs_surge_percent_increase_prompt =
                "(" + this.etofs_surge_percent + "%)";
            }
            var offset_percentage = etsrgsfc - this.relativeOffset;
            etsrgsfc =
              etsrgsfc + offset_percentage * (this.etofs_surge_percent / 100);
            etsrgsfc = parseFloat(sprintf(this.dt_format, etsrgsfc));
          }
          break;
        }
      }
      // wave height wave period observed
      obsWaveHeight = -9999.99;
      obsWavePeriod = -9999.99;
      if (this.erddapWaveHeightObservationData != undefined) {
        // hs sea_surface_wave_significant_height
        // swp sea_surface_wave_frequency
        var time_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
          this.erddapWaveHeightObservationData.table.columnNames,
          "time"
        );
        var hs_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
          this.erddapWaveHeightObservationData.table.columnNames,
          "significant_wave_height"
        );
        var swp_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
          this.erddapWaveHeightObservationData.table.columnNames,
          "dominant_wave_period"
        );
        var hs_index_qc = this.appConfig.ERDDAPColumnIndexFromColumnName(
          this.erddapWaveHeightObservationData.table.columnNames,
          "significant_wave_height_qc"
        );
        var swp_index_qc = this.appConfig.ERDDAPColumnIndexFromColumnName(
          this.erddapWaveHeightObservationData.table.columnNames,
          "dominant_wave_period_qc"
        );
        for (var dww_key in this.erddapWaveHeightObservationData.table.rows) {
          let resultdatetext: any = this.erddapWaveHeightObservationData.table
            .rows[dww_key][time_index];
          // Date.parse("2016-03-31T13:00:00Z")
          var rdt_temp =
            resultdatetext.substr(0, 4) +
            "/" +
            resultdatetext.substr(5, 2) +
            "/" +
            resultdatetext.substr(8, 2) +
            " " +
            resultdatetext.substr(11, 8) +
            " GMT";
          var resultdatems = Date.parse(rdt_temp);

          if (resultdatems == pointdatems) {
            var obsWaveHeight = this.erddapWaveHeightObservationData.table.rows[
              dww_key
            ][hs_index];
            var obsWavePeriod = this.erddapWaveHeightObservationData.table.rows[
              dww_key
            ][swp_index];
            break;
          }
        }
      } else {
        if (
          buoy_data != undefined &&
          buoy_data["time_series-significant_height_of_wind_and_swell_waves"] !=
            undefined
        ) {
          for (var bd_key in buoy_data[
            "time_series-significant_height_of_wind_and_swell_waves"
          ]) {
            resultdatetext = bd_key;
            // adding two zeros seems to do the trick
            // Date.parse("2015-09-30 07:00:00-0400")
            resultdatetext += "00";
            // var resultdatems = Date.parse(resultdatetext);
            // .getTime();
            // change 2017-06-01 00:00:00-0400
            // to 2017/06/01 00:00:00-0400
            // wave data seems to have a T in it? So skip that character everywhere.
            // "2017/06/05T01:00:00Z"
            // var rdt_temp = resultdatetext.replace(/-/g, '/').replace(/[a-z]+/gi, ' ');
            var rdt_temp =
              resultdatetext.substr(0, 4) +
              "/" +
              resultdatetext.substr(5, 2) +
              "/" +
              resultdatetext.substr(8, 2) +
              " " +
              resultdatetext.substr(11);
            var resultdatems = Date.parse(rdt_temp);
            var pointdatems = Date.parse(pointDate.toString()); // .getTime() ;
            if (resultdatems == pointdatems) {
              obsWaveHeight =
                buoy_data[
                  "time_series-significant_height_of_wind_and_swell_waves"
                ][bd_key][0].reading;
              break;
            }
          }
          for (var bd_key in buoy_data["time_series-dominant_wave_period"]) {
            resultdatetext = bd_key;
            // adding two zeros seems to do the trick
            // Date.parse("2015-09-30 07:00:00-0400")
            resultdatetext += "00";
            // var resultdatems = Date.parse(resultdatetext); // .getTime();
            // change 2017-06-01 00:00:00-0400
            // to 2017/06/01 00:00:00-0400
            // wave data seems to have a T in it? So skip that character everywhere.
            // "2017/06/05T01:00:00Z"
            // var rdt_temp = resultdatetext.replace(/-/g, '/').replace(/[a-z]+/gi, ' ');
            var rdt_temp =
              resultdatetext.substr(0, 4) +
              "/" +
              resultdatetext.substr(5, 2) +
              "/" +
              resultdatetext.substr(8, 2) +
              " " +
              resultdatetext.substr(11);
            var resultdatems = Date.parse(rdt_temp);
            var pointdatems = Date.parse(pointDate.toString()); // .getTime() ;
            if (resultdatems == pointdatems) {
              obsWavePeriod =
                buoy_data["time_series-dominant_wave_period"][bd_key][0]
                  .reading;
              break;
            }
          }
        }
      }
      if (obsWaveHeight > 0 && obsWavePeriod > 0) {
        // wave height is in meters.
        var obsWaveHeightM = obsWaveHeight;
        var obsWaveLengthM = this.appConfig.calculatedWaveLength(
          obsWavePeriod,
          obsWaveHeightM
        );
        obsWaveLength = this.appConfig.gmriUnits.conv_meters_to_feet(
          obsWaveLengthM
        );
        obsWaveHeight = this.appConfig.gmriUnits.conv_meters_to_feet(
          obsWaveHeightM
        );
      } else {
        var temp = "temp";
      }
      // wave height wave period forecasted
      var have_wave_height = false;
      var have_wave_length = false;
      // don't mix and match bioww3 and erddap sources any more
      // the locations are too different
      if (!use_erddap_dww) {
        for (var bioww3_key in bioww3_data.data) {
          resultdatetext = bioww3_data.data[bioww3_key].reading_ts;
          // adding 4 zeros seems to do the trick
          // Date.parse("2015-09-30 08:00:00")
          resultdatetext += "-0000";
          // var resultdatems = Date.parse(resultdatetext); // .getTime();
          // change 2017-06-01 00:00:00-0400
          // to 2017/06/01 00:00:00-0400
          // wave data seems to have a T in it? So skip that character everywhere.
          // "2017/06/05T01:00:00Z"
          // var rdt_temp = resultdatetext.replace(/-/g, '/').replace(/[a-z]+/gi, ' ');
          var rdt_temp =
            resultdatetext.substr(0, 4) +
            "/" +
            resultdatetext.substr(5, 2) +
            "/" +
            resultdatetext.substr(8, 2) +
            " " +
            resultdatetext.substr(11, 19);
          var resultdatems = Date.parse(rdt_temp);
          // 1443600000000
          // Wed Sep 30 2015 04:00:00 GMT-0400 (EDT)
          var pointdatems = Date.parse(this.appConfig.dataTypeFormatString); // .getTime();
          if (resultdatems == pointdatems) {
            var data_type = bioww3_data.data[bioww3_key].data_type;
            // only one type is delivered back.
            // E_FINE or COARSE  at the moment.
            var bioww3_wave_height;
            var bioww3_wave_length;
            switch (data_type) {
              case "E_FINE_FORECAST_MEAN_WAVE_LENGTH":
                bioww3_wave_length = bioww3_data.data[bioww3_key].reading;
                have_wave_length = true;
                break;
              case "E_FINE_FORECAST_SIGNIFICANT_WAVE_HEIGHT":
                bioww3_wave_height = bioww3_data.data[bioww3_key].reading;
                have_wave_height = true;
                break;
              case "E_FINE_FORECAST_MEAN_WAVE_PERIOD":
                wavePeriod = bioww3_data.data[bioww3_key].reading;
                break;
              case "COARSE_FORECAST_MEAN_WAVE_LENGTH":
                bioww3_wave_length = bioww3_data.data[bioww3_key].reading;
                have_wave_length = true;
                break;
              case "COARSE_FORECAST_SIGNIFICANT_WAVE_HEIGHT":
                bioww3_wave_height = bioww3_data.data[bioww3_key].reading;
                have_wave_height = true;
                break;
              case "COARSE_FORECAST_MEAN_WAVE_PERIOD":
                wavePeriod = bioww3_data.data[bioww3_key].reading;
                break;
            }
            if (have_wave_height && have_wave_length) {
              // waveLength = this.appConfig.gmriUnits.conv_meters_to_feet(bioww3_wave_length);
              // 4-17-2016 It appears that despite the labeling in the bioww3 file this is in feet?
              waveLength = bioww3_wave_length;
              waveHeight = this.appConfig.gmriUnits.conv_meters_to_feet(
                bioww3_wave_height
              );
              break;
            }
          }
        }
      }

      // see if necofs is available
      if (check_for_necofs_first) {
        // Check for necofs data
        if (
          this.necofs_wave_data != undefined &&
          this.necofs_wavelength_data != undefined
        ) {
          if (this.necofs_wave_data.data.length > 72) {
            // && necofs_point_count < 50) {
            this.necofs_wave_data_found = true;
          }
        }
      }
      // if it's not available fall back to ww3global
      if (!this.necofs_wave_data_found && wave_model_name == "NECOFS") {
        wave_model_name = "WW3GLOBAL";
      }
      // see if ww3 bedford is available
      if (dww_data.table.rows.length > 10) {
        this.ww3_bedford_wave_data_found = true;
      }
      // if it's not available fall back to ww3global
      if (!this.ww3_bedford_wave_data_found && wave_model_name == "WW3") {
        wave_model_name = "WW3GLOBAL";
      }
      switch (wave_model_name) {
        case "NECOFS":
          for (var dww_key in this.necofs_wave_data.data) {
            var resultdatems = parseInt(this.necofs_wave_data.data[dww_key][0]);
            var pointdatems = Date.parse(pointDate.toString());
            if (resultdatems == pointdatems) {
              var waveHeightM = this.necofs_wave_data.data[dww_key][1];
              if (wave_percent != 0) {
                waveHeightM = waveHeightM + waveHeightM * (wave_percent / 100);
                if (wave_percent > 0) {
                  this.wave_percent_increase_prompt =
                    "(+" + wave_percent + "%)";
                } else {
                  this.wave_percent_increase_prompt = "(" + wave_percent + "%)";
                }
              }
              waveHeight = this.appConfig.gmriUnits.conv_meters_to_feet(
                waveHeightM
              );
              break;
            }
          }
          for (var dww_key in this.necofs_wavelength_data.data) {
            var resultdatems = parseInt(
              this.necofs_wavelength_data.data[dww_key][0]
            );
            var pointdatems = Date.parse(pointDate.toString());
            if (resultdatems == pointdatems) {
              var waveLengthM = this.necofs_wavelength_data.data[dww_key][1];
              waveLength = this.appConfig.gmriUnits.conv_meters_to_feet(
                waveLengthM
              );
              break;
            }
          }
          break;
        case "WW3":
          // wave height wave period forecasted from ERDDAP
          if (use_erddap_dww && dww_data != undefined) {
            // hs sea_surface_wave_significant_height
            // swp sea_surface_wave_frequency
            // 2-26-2018 new 72 hour forecast is available swp is now fp (wave peak frequency, s-1)
            var hs_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
              dww_data.table.columnNames,
              "hs"
            );
            var swp_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
              dww_data.table.columnNames,
              "fp"
            );
            for (var dww_key in dww_data.table.rows) {
              resultdatetext = dww_data.table.rows[dww_key][0];
              // Date.parse("2016-03-31T13:00:00Z")
              // var resultdatems = Date.parse(resultdatetext); // .getTime();

              // change 2017-06-01 00:00:00-0400
              // to 2017/06/01 00:00:00-0400
              // wave data seems to have a T in it? So skip that character everywhere.
              // "2017/06/05T01:00:00Z" ended up replace Z with space Z I could have also
              // done what the bioww3 code does above and added -0000 for no offset.
              // var rdt_temp = resultdatetext.replace(/-/g, '/').replace(/[a-z]+/gi, ' ');
              var rdt_temp =
                resultdatetext.substr(0, 4) +
                "/" +
                resultdatetext.substr(5, 2) +
                "/" +
                resultdatetext.substr(8, 2) +
                " " +
                resultdatetext.substr(11, 8) +
                " GMT";
              var resultdatems = Date.parse(rdt_temp);
              // 1443600000000
              // Wed Sep 30 2015 04:00:00 GMT-0400 (EDT)
              // var pointdatems = Date.parse(this.appConfig.dataTypeFormatString); // .getTime();
              var pointdatems = Date.parse(pointDate.toString());
              if (resultdatems == pointdatems) {
                var waveHeightM = dww_data.table.rows[dww_key][hs_index];
                if (wave_percent != 0) {
                  waveHeightM =
                    waveHeightM + waveHeightM * (wave_percent / 100);
                  if (wave_percent > 0) {
                    this.wave_percent_increase_prompt =
                      "(+" + wave_percent + "%)";
                  } else {
                    this.wave_percent_increase_prompt =
                      "(" + wave_percent + "%)";
                  }
                }
                // ww3 72 hours is per second s-1. The calculation used period
                wavePeriod = 1 / dww_data.table.rows[dww_key][swp_index];
                // sample data hs, swp, dir. there's no way this is 2.95 cycles per second
                // 0.8, 2.95, 315.0
                /// wavePeriod = 1/waveFrequency ;
                var waveLengthM = this.appConfig.calculatedWaveLength(
                  wavePeriod,
                  waveHeightM
                );
                waveLength = this.appConfig.gmriUnits.conv_meters_to_feet(
                  waveLengthM
                );
                waveHeight = this.appConfig.gmriUnits.conv_meters_to_feet(
                  waveHeightM
                );
                break;
              }
            }
          }
          break;
        case "WW3GLOBAL":
          // wave height wave period forecasted from ERDDAP
          if (use_erddap_dww && this.waveGlobalPredictionData != undefined) {
            // hs sea_surface_wave_significant_height
            // swp sea_surface_wave_frequency
            var hs_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
              this.waveGlobalPredictionData.table.columnNames,
              "Thgt"
            );
            var swp_index = this.appConfig.ERDDAPColumnIndexFromColumnName(
              this.waveGlobalPredictionData.table.columnNames,
              "Tper"
            );
            for (var dww_key in this.waveGlobalPredictionData.table.rows) {
              resultdatetext = this.waveGlobalPredictionData.table.rows[
                dww_key
              ][0];
              // Date.parse("2016-03-31T13:00:00Z")
              // var resultdatems = Date.parse(resultdatetext); // .getTime();

              // change 2017-06-01 00:00:00-0400
              // to 2017/06/01 00:00:00-0400
              // wave data seems to have a T in it? So skip that character everywhere.
              // "2017/06/05T01:00:00Z" ended up replace Z with space Z I could have also
              // done what the bioww3 code does above and added -0000 for no offset.
              // var rdt_temp = resultdatetext.replace(/-/g, '/').replace(/[a-z]+/gi, ' ');
              var rdt_temp =
                resultdatetext.substr(0, 4) +
                "/" +
                resultdatetext.substr(5, 2) +
                "/" +
                resultdatetext.substr(8, 2) +
                " " +
                resultdatetext.substr(11, 8) +
                " GMT";
              var resultdatems = Date.parse(rdt_temp);
              // 1443600000000
              // Wed Sep 30 2015 04:00:00 GMT-0400 (EDT)
              // var pointdatems = Date.parse(this.appConfig.dataTypeFormatString); // .getTime();
              var pointdatems = Date.parse(pointDate.toString());
              if (resultdatems == pointdatems) {
                var waveHeightM = this.waveGlobalPredictionData.table.rows[
                  dww_key
                ][hs_index];
                if (wave_percent != 0) {
                  waveHeightM =
                    waveHeightM + waveHeightM * (wave_percent / 100);
                  if (wave_percent > 0) {
                    this.wave_percent_increase_prompt =
                      "(+" + wave_percent + "%)";
                  } else {
                    this.wave_percent_increase_prompt =
                      "(" + wave_percent + "%)";
                  }
                }
                wavePeriod = this.waveGlobalPredictionData.table.rows[dww_key][
                  swp_index
                ];
                // sample data hs, swp, dir. there's no way this is 2.95 cycles per second
                // 0.8, 2.95, 315.0
                /// wavePeriod = 1/waveFrequency ;
                var waveLengthM = this.appConfig.calculatedWaveLength(
                  wavePeriod,
                  waveHeightM
                );
                waveLength = this.appConfig.gmriUnits.conv_meters_to_feet(
                  waveLengthM
                );
                waveHeight = this.appConfig.gmriUnits.conv_meters_to_feet(
                  waveHeightM
                );
                break;
              }
            }
          }
          break;
      }

      // add a check here for wave < 0. -9999 data is coming in
      // don't limit to wave height now
      // if ( waveHeight > 0 ) {
      if (1) {
        // add a forecast point
        // pass in the relative offset. duneCrest and other parameters are
        // only set once. while waveHeight etc change fore each point.
        var sp = new stockton_point(
          pointDate,
          this.slope,
          this.dune_crest,
          this.dune_base,
          waveHeight,
          wavePeriod,
          waveLength,
          obsWaveHeight,
          obsWavePeriod,
          obsWaveLength,
          etcwlsfc,
          elevsfc,
          etsrgsfc,
          etofs_debug_data,
          this.relativeOffset,
          this.appConfig.dataTypeFormatString("water_level")
        );
        this.stocktonPointForecasts.push(sp);
        if (sp.max_value > this.max_value) {
          this.max_value = sp.max_value;
        }
        if (sp.max_waterlevel > this.max_waterlevel) {
          this.max_waterlevel = sp.max_waterlevel;
        }
        if (sp.min_waterlevel < this.min_waterlevel) {
          this.min_waterlevel = sp.min_waterlevel;
        }
        // I need to reconcile these with the power point.
        // I'm using Rhigh in absence of any sense.
        // R1 > Dune = inundation,
        // R2 > Dune = over wash (even if R1 is below height of dune, waves cause over wash)
        // R2 reaches base of dune (even a trickle) = Erosion  - he’s unsure of threshold -
        // watch for the peaks
        // start off with the current value
        if (this.peak_count < 8 && sp.Rhigh != undefined) {
          switch (peak_finding_status) {
            case "beginning":
              if (current_peak == 0) {
                current_peak_point = sp;
                current_peak = sp.Rhigh;
                current_peak_date = sp.date;
                last_peak = current_peak;
                last_peak_date = current_peak_date;
                current_peak_rlow = sp.Rlow;
                last_peak_rlow = current_peak_rlow;
              } else {
                // if the new high is greater than the current peak
                if (sp.Rhigh > current_peak) {
                  current_peak_point = sp;
                  current_peak = sp.Rhigh;
                  current_peak_rlow = sp.Rlow;
                  current_peak_date = sp.date;
                  peak_finding_status = "going_up";
                } else {
                  last_peak = current_peak;
                  last_peak_rlow = current_peak_rlow;
                  current_peak_point = sp;
                  current_peak = sp.Rhigh;
                  current_peak_rlow = sp.Rlow;
                  current_peak_date = sp.date;
                  peak_finding_status = "going_down";
                }
              }
              break;
            case "going_down":
              // if the new high is greater than the current peak
              if (sp.Rhigh > current_peak) {
                last_peak = current_peak;
                last_peak_rlow = current_peak_rlow;
                current_peak_point = sp;
                current_peak = sp.Rhigh;
                current_peak_rlow = sp.Rlow;
                current_peak_date = sp.date;
                peak_finding_status = "going_up";
              } else {
                last_peak = current_peak;
                last_peak_rlow = current_peak;
                current_peak_point = sp;
                current_peak = sp.Rhigh;
                current_peak_rlow = sp.Rlow;
                current_peak_date = sp.date;
              }
              break;
            case "going_up":
              // if the new high is greater than the current peak
              if (sp.Rhigh > current_peak) {
                last_peak = current_peak;
                last_peak_rlow = current_peak_rlow;
                last_peak_date = current_peak_date;
                current_peak_point = sp;
                current_peak = sp.Rhigh;
                current_peak_rlow = sp.Rlow;
                current_peak_date = sp.date;
              } else {
                // going down.
                // reached a high
                this.setPeakValues(
                  current_peak_rlow,
                  current_peak,
                  current_peak,
                  this.peak_count,
                  current_peak_date,
                  current_peak_point
                );
                // start a new peak
                this.peak_count++;
                last_peak = 0;
                current_peak = 0;
                current_peak_rlow = 0;
                peak_finding_status = "beginning";
              }
              break;
          }
        }
      }
    }

    if (validPointsFound["ESTOFS"] == false) {
      failedExplaination["ESTOFS"] =
        "Extra Tropical Storm Surge Data Unavailable";
      // flag this as not being initialized so it will try loading again next time.
      this.surgeObject.initialized = false;
    }
    test_output += "</table>";
    // assemble some parameters for the display
    switch (units) {
      case "feet":
        this.display_dune_crest = sprintf(
          dt_format + " ft",
          this.dune_crest - this.relativeOffset
        );
        this.display_dune_base = sprintf(
          dt_format + " ft",
          this.dune_base - this.relativeOffset
        );
        this.display_MSL = sprintf(dt_format + " ft", this.tideMSL);
        this.display_NAVD88 = sprintf(dt_format + " ft", this.tideNAVD88);
        this.display_MLLW = sprintf(dt_format + " ft", this.tideMLLW);
        this.display_MHHW = sprintf(dt_format + " ft", this.tideMHHW);
        break;
      case "meters":
        this.display_dune_crest = sprintf(
          dt_format + " m",
          this.dune_crest - this.relativeOffset
        );
        break;
      default:
        break;
    }
    this.forecast_complete_html_table = test_output;
    this.max_sf_point = this.getMaxSFPoint();
    if (this.peak_count < 2) {
      failedExplaination["PEAK_COUNT"] = "Not enough data to complete forecast";
    }
    // set up and order for the display code to iterate through
    this.peak_order = [];
    // latest on top drag lights
    // for ( let i: number = 0; i < this.peak_count; i++ ) {
    //   this.peak_order.push(i);
    //}
    // earliest top latest bottom
    for (let i: number = this.peak_count - 1; i > -1; i--) {
      this.peak_order.push(i);
    }
    let ret_array: any = [];
    ret_array["test_output"] = test_output;
    ret_array["failedExplainations"] = failedExplaination;
    return ret_array;
  }
  setPeakValues(
    peak_inundation,
    peak_over_wash,
    peak_erosion,
    peak_index,
    peak_date,
    current_peak_point
  ) {
    var debugging_force_over = 0.0; // 7.5 ;
    let flagged_an_event: boolean = false;
    if (
      peak_inundation >
        this.dune_crest - this.relativeOffset - debugging_force_over &&
      !flagged_an_event
    ) {
      this.inundation[peak_index] = true;
      this.alarm_timestamp[peak_index] = peak_date;
      flagged_an_event = true;
    }
    if (
      peak_over_wash >
        this.dune_crest - this.relativeOffset - debugging_force_over &&
      !flagged_an_event
    ) {
      this.over_wash[peak_index] = true;
      this.alarm_timestamp[peak_index] = peak_date;
      flagged_an_event = true;
    }
    if (
      peak_erosion >=
        this.dune_base - this.relativeOffset - debugging_force_over &&
      !flagged_an_event
    ) {
      this.erosion[peak_index] = true;
      this.alarm_timestamp[peak_index] = peak_date;
      flagged_an_event = true;
    }
    // just save the peak values peak_over_wash is Rhigh
    // and greater than rlow despite rlow being inundation.
    this.peak_values[peak_index] = peak_over_wash;
    this.peak_values_timestamp[peak_index] = peak_date;
    // and do this formatting because I can't add <br> into the display code it seems.
    this.peak_values_hm_ampm[peak_index] = this.appConfig.formatAMPM(peak_date);
    var month = peak_date.getMonth() + 1;
    this.peak_values_md[peak_index] = month + "/" + peak_date.getDate();
    // now save the entire point
    this.peak_points[peak_index] = current_peak_point;
  }
  // create a config object from a stockton numbers
  stocktonChartConfig2(parameters, surgeService, wave_model_name) {
    var ret_array = [];
    var new_series = [];
    var yaxis_array = [];
    var count = 0;
    var toggle_opposite = false;
    var param_time_series = [];
    var param_time_series_range = [];
    var chart_max = 0; // keep track of the maximum so I can add a dummy marker
    var chart_max_time;
    var chart_min = 100;
    var min_xaxis_time = new Date().getTime();
    // loop through the points
    var point_count = 0;
    var tide_surge_variability = surgeService.appConfig.getTSVariability();
    var dt_format = surgeService.appConfig.dataTypeFormatString("water_level");
    var pwl_percent = surgeService.appConfig.getPWLPercent();
    var pwl_percent_prompt = surgeService.appConfig.getPWLPrompt();
    var use_custom_hover = true;
    // try not setting the end point for Rhigh to see if the graph will stop flickering
    let num_points: number = this.stocktonPointForecasts.length;
    let rhigh_point_count: number = 0;
    // walk the stockton points in sf.stocktonPointForecasts
    for (var sf_key in this.stocktonPointForecasts) {
      var sp = this.stocktonPointForecasts[sf_key];
      // stockton points
      // HOL0
      // R2:"N/A"
      // Rhigh:"N/A"
      // Rlow:"N/A"
      // date:Wed May 25 2016 01:00:00 GMT-0400 (EDT)
      // elevsfc:4.66
      // ....
      var pointdatems = Date.parse(sp.date.toString());
      // save this for the minimum value on the chart x axis
      if (pointdatems < min_xaxis_time) {
        min_xaxis_time = pointdatems;
      }
      var visibility_series_index = 0; // for keeping track of series visibility changes
      var dashStyle = "none";
      for (var sp_key in sp) {
        dashStyle = "none";
        if (parameters.indexOf(sp_key) != -1) {
          if (sp_key != "date") {
            // use the first sp object to set up a number of objects (lines) to plot
            // this is walking those H0L0, R2, Rhigh and so forth and so on
            if (parseInt(sf_key) == 0) {
              var parameter_ts_name = "time_series-" + sp_key;
              let new_series_object: any = {};
              // nothing to do with highcharts It's to match the point data
              // accumulation array later on.
              new_series_object.sp_key = sp_key;
              // limit what is displayed here by simply not including things.
              if (
                this.appConfig.stocktonDisplayedParameters[sp_key] !=
                  undefined &&
                this.appConfig.stocktonDisplayedParameters[sp_key]
              ) {
                new_series.push(new_series_object);
              }
              // value suffix object
              let new_vs: any = {};
              // new_vs.xDateFormat = '%Y-%m-%d' ;
              new_vs.shared = true;
              new_vs.crosshairs = true;
              new_vs.valueSuffix = " " + this.units;
              // new_vs.headerFormat = '<span style="font-size: 10px">{point.key}</span><br/>';
              // similare to php's strftime, however, strftime seems to have no options for timezones!
              // but highcharts has a global flag useUTC which you can set to false.
              // and at least show the local timezone.
              new_vs.xDateFormat = "%A %m-%d-%Y %I:%M %p";
              var ns_series_name = sp_key;
              var color;
              var visible = true;
              var line_type = "spline";
              // http://www.w3schools.com/colors/colors_picker.asp
              switch (sp_key) {
                case "elevsfc": // surface ocean surface elevation relative to geoid (tide) [m] "
                  ns_series_name = surgeService.appConfig.getETOFSTIDEPrompt();
                  color = surgeService.appConfig.plotColors["elevsfc"];
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "TIDE_ETOFS_TIDE"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      // event.preventDefault();
                      // var seriesIndex = surgeService.appConfig.seriesIndex(this.yAxis.series, surgeService.appConfig.getETOFSTIDEPrompt());
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getETOFSTIDEPrompt()
                        );
                        /*
                            var visibility = this.visible ? 'visible' : 'hidden';
                            if (!confirm(surgeService.appConfig.getETOFSTIDEPrompt() + '  currently ' +
                                         visibility + '. Do you want to change that?')) {
                                return false;
                            } else {
                            */
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_ETOFS_TIDE",
                            false
                          );
                          // this.yAxis.series[seriesIndex].visible = false ;
                          // event.target.visible = false ;
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_ETOFS_TIDE",
                            true
                          );
                          // this.yAxis.series[seriesIndex].visible = true ;
                          // event.target.visible = true ;
                        }
                        /*
                            }
                            */
                      }
                    }
                  };
                  if (this.etofs_tide_percent != 0) {
                    ns_series_name += this.etofs_tide_percent_increase_prompt;
                  }
                  visibility_series_index++;
                  break;
                case "etsrgsfc": // surface extra tropical storm surge [m] "
                  ns_series_name = surgeService.appConfig.getVariousPrompts(
                    "ETOFS_SURGE"
                  );
                  color = surgeService.appConfig.plotColors["etsrgsfc"];
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "TIDE_ETOFS_SURGE"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getVariousPrompts(
                            "ETOFS_SURGE"
                          )
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_ETOFS_SURGE",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_ETOFS_SURGE",
                            true
                          );
                        }
                      }
                    }
                  };
                  if (this.etofs_surge_percent != 0) {
                    ns_series_name += this.etofs_surge_percent_increase_prompt;
                  }
                  visibility_series_index++;
                  break;
                case "etsurgeplustide": // surface extra tropical storm surge combined surge and tide [m] "
                  // this is the augmented values for surge and tide
                  ns_series_name = surgeService.appConfig.getAugmentedPWLPrompt();
                  color = surgeService.appConfig.plotColors["etsurgeplustide"];
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "TIDE_AUGMENTED_ETOFS_SURGE_TIDE"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getPWLPrompt()
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_AUGMENTED_ETOFS_SURGE_TIDE",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_AUGMENTED_ETOFS_SURGE_TIDE",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  // This single spot will let you remove or add this range for surge + tide
                  // 6-8-2016 right now it seems to have served its purpose ( a de mo )
                  // and is just noise so I'm removing it.
                  // new_series.push( new_series_object_range );
                  if (use_custom_hover) {
                    new_vs.pointFormatter = function() {
                      return (
                        '<span style="color:' +
                        this.color +
                        '">\u25CF</span> ' +
                        this.series.name +
                        ": <b>" +
                        this.y +
                        "</b> " +
                        this.series.tooltipOptions.valueSuffix +
                        "<br/>"
                      );
                    };
                  }
                  break;
                case "etcwlsfc": // surface extra tropical storm surge combined surge and tide [m] "
                  ns_series_name = surgeService.appConfig.getPWLPrompt();
                  color = surgeService.appConfig.plotColors["etcwlsfc"];
                  // adding a range for this series.
                  let new_series_object_range: any = {};
                  // nothing to do with highcharts It's to match the point data
                  // accumulation array later on.
                  new_series_object_range.sp_key = sp_key;
                  new_series_object_range.name =
                    "+- " + tide_surge_variability + "%";
                  new_series_object_range.color =
                    surgeService.appConfig.plotColors["SurgeTideRange"];
                  (new_series_object_range.dashStyle = "shortdash"),
                    (new_series_object_range.tooltip = new_vs);
                  new_series_object_range.type = "arearange";
                  new_series_object_range.yAxis = 0;
                  new_series_object_range.visible = true;
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "TIDE_ETOFS_SURGE_TIDE"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getPWLPrompt()
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_ETOFS_SURGE_TIDE",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_ETOFS_SURGE_TIDE",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  // This single spot will let you remove or add this range for surge + tide
                  // 6-8-2016 right now it seems to have served its purpose ( a de mo )
                  // and is just noise so I'm removing it.
                  // new_series.push( new_series_object_range );
                  if (use_custom_hover) {
                    new_vs.pointFormatter = function() {
                      return (
                        '<span style="color:' +
                        this.color +
                        '">\u25CF</span> ' +
                        this.series.name +
                        ": <b>" +
                        this.y +
                        "</b> " +
                        this.units +
                        "<br/>"
                      );
                    };
                  }
                  if (this.pwl_percent != 0) {
                    ns_series_name += this.pwl_percent_increase_prompt;
                  }
                  break;
                case "Rhigh":
                  // line_type = 'column';
                  line_type = "spline";
                  dashStyle = "dot";
                  color = surgeService.appConfig.plotColors["Rhigh"];
                  ns_series_name = surgeService.appConfig.getVariousPrompts(
                    "RHIGH"
                  );
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "RHIGH"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getVariousPrompts("RHIGH")
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "RHIGH",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "RHIGH",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  break;
                case "Rlow":
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "RLOW"
                  );
                  ns_series_name = surgeService.appConfig.getVariousPrompts(
                    "RLOW"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getVariousPrompts("RLOW")
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "RLOW",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "RLOW",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  break;
                case "waveHeight":
                  // line_type = 'column';
                  line_type = "spline";
                  color =
                    surgeService.appConfig.plotColors["predicted_wave_height"];
                  // another kludgy piece of logic. If NECOFS was selected but the necofs data
                  // wasn't found then revert back to WW3 Global
                  if (
                    this.necofs_wave_data_found &&
                    wave_model_name == "NECOFS"
                  ) {
                    ns_series_name = surgeService.appConfig.getVariousPrompts(
                      "NECOFS_PREDICTED_WAVE_HEIGHT"
                    );
                    surgeService.appConfig.wave_model_used = wave_model_name;
                  } else {
                    switch (wave_model_name) {
                      case "WW3":
                        ns_series_name = surgeService.appConfig.getVariousPrompts(
                          "ERDDAP_PREDICTED_WAVE_HEIGHT"
                        );
                        surgeService.appConfig.wave_model_used = wave_model_name;
                        break;
                      case "WW3GLOBAL":
                        ns_series_name = surgeService.appConfig.getVariousPrompts(
                          "ERDDAP_WW3GLOBAL_PREDICTED_WAVE_HEIGHT"
                        );
                        surgeService.appConfig.wave_model_used = wave_model_name;
                        break;
                      case "NECOFS":
                        // if we get here then the user asked to use NECOFS but it's not yet available.
                        ns_series_name = surgeService.appConfig.getVariousPrompts(
                          "ERDDAP_WW3GLOBAL_PREDICTED_WAVE_HEIGHT"
                        );
                        surgeService.appConfig.wave_model_used = "WW3GLOBAL";
                        break;
                      default:
                        ns_series_name =
                          "Wave Model " +
                          wave_model_name +
                          " for " +
                          this.name +
                          " is unknown";
                        break;
                    }
                  }
                  var visibility_check_series_name = ns_series_name;
                  ns_series_name += this.wave_percent_increase_prompt;
                  // augment this
                  new_vs.valueSuffix =
                    " " + this.units + this.wave_percent_increase_prompt;
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "INUNDATION_MODEL_PREDICTED_WAVE_HEIGHT"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        // var visible_value = surgeService.appConfig.gmriUnits.visibleValue(this.yAxis.series, surgeService.appConfig.getVariousPrompts('INUNDATION_MODEL_PREDICTED_WAVE_HEIGHT') ) ;
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          visibility_check_series_name
                        );
                        if (visible_value) {
                          // the check for this.necofs_wave_data_found isn't working on my ipad but
                          // in reality it doesn't matter much. They either are toggling wave information
                          // on or off and dont' care where it came from!
                          //  surgeService.appConfig.setUserPreferenceParameterVisibility('NECOFS_PREDICTED_WAVE_HEIGHT', false) ;
                          // surgeService.appConfig.setUserPreferenceParameterVisibility('ERDDAP_PREDICTED_WAVE_HEIGHT', false) ;
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "INUNDATION_MODEL_PREDICTED_WAVE_HEIGHT",
                            false
                          );
                        } else {
                          //surgeService.appConfig.setUserPreferenceParameterVisibility('NECOFS_PREDICTED_WAVE_HEIGHT', true) ;
                          //surgeService.appConfig.setUserPreferenceParameterVisibility('ERDDAP_PREDICTED_WAVE_HEIGHT', true) ;
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "INUNDATION_MODEL_PREDICTED_WAVE_HEIGHT",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  break;
                case "obsWaveHeight":
                  // line_type = 'column';
                  line_type = "spline";
                  color =
                    surgeService.appConfig.plotColors["observed_wave_height"];
                  ns_series_name = surgeService.appConfig.getVariousPrompts(
                    "BUOY_OBS_WAVE_HEIGHT"
                  );
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "BUOY_OBS_WAVE_HEIGHT"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getVariousPrompts(
                            "BUOY_OBS_WAVE_HEIGHT"
                          )
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "BUOY_OBS_WAVE_HEIGHT",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "BUOY_OBS_WAVE_HEIGHT",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  break;
                case "observed_waterLevel": // from tides and currents
                  ns_series_name = "Obs Water Level";
                  ns_series_name = surgeService.appConfig.getVariousPrompts(
                    "TIDE_OBS_WATER_LEVEL"
                  );
                  color =
                    surgeService.appConfig.plotColors["observed_water_level"];
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "TIDE_OBS_WATER_LEVEL"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getVariousPrompts(
                            "TIDE_OBS_WATER_LEVEL"
                          )
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_OBS_WATER_LEVEL",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "TIDE_OBS_WATER_LEVEL",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  break;
                case "R2": // from tides and currents
                  ns_series_name = surgeService.appConfig.getVariousPrompts(
                    "R2"
                  );
                  color = surgeService.appConfig.plotColors["R2"];
                  visible = surgeService.appConfig.getInterfaceLevelParameterVisibilty(
                    surgeService,
                    "R2"
                  );
                  new_series_object.events = {
                    legendItemClick: function(event) {
                      // we're toggling from this value
                      // I could have used the event here too it seems.
                      // ios issues two events touchstart and click. Highcharts toggles
                      // the visibility on both events. for example Press see, release don't see.
                      // Click is the only event in the browser So on click register the change of state
                      // and on touchstart undo the change.
                      if (event.browserEvent.type == "touchstart") {
                        event.target.visible = !event.target.visible;
                      }
                      if (event.browserEvent.type == "click") {
                        var visible_value = surgeService.appConfig.gmriUnits.visibleValue(
                          this.yAxis.series,
                          surgeService.appConfig.getVariousPrompts("R2")
                        );
                        if (visible_value) {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "R2",
                            false
                          );
                        } else {
                          surgeService.appConfig.setUserPreferenceParameterVisibility(
                            "R2",
                            true
                          );
                        }
                      }
                    }
                  };
                  visibility_series_index++;
                  break;
                default:
                  line_type = "spline";
                  break;
              }
              new_series_object.name = ns_series_name;
              new_series_object.tooltip = new_vs;
              new_series_object.visible = visible;
              new_series_object.type = line_type;
              if (color != undefined) {
                new_series_object.color = color;
              }
              if (dashStyle != "none") {
                new_series_object.dashStyle = dashStyle;
              }
              // new_series_object.yAxis = count;
              // yaxis_key = sp_key ; // individual scales per line
              // the individual scales are old and don't take into account the range series.
              var yaxis_key = 0;
              if (yaxis_array[yaxis_key] == undefined) {
                yaxis_array[yaxis_key] = {};

                let new_label: any = {};
                new_label.format = "{value} " + yaxis_key;

                let new_title: any = {};
                // new_title.text = yaxis_key ;
                new_title.text = "feet";

                yaxis_array[yaxis_key].labels = new_label;
                yaxis_array[yaxis_key].title = new_title;
                yaxis_array[yaxis_key].opposite = toggle_opposite;
                yaxis_array[yaxis_key].min = this.min_waterlevel;
                // check for a dune crest > the max waterlevel and use it
                if (
                  this.dune_crest - this.relativeOffset >
                  this.max_waterlevel
                ) {
                  yaxis_array[yaxis_key].max =
                    this.dune_crest - this.relativeOffset;
                  yaxis_array[yaxis_key].minRange =
                    this.dune_crest - this.relativeOffset;
                } else {
                  yaxis_array[yaxis_key].max = this.max_waterlevel;
                  yaxis_array[yaxis_key].minRange = this.max_waterlevel;
                }
                if (yaxis_array[yaxis_key].max > chart_max) {
                  chart_max = yaxis_array[yaxis_key].max;
                  chart_max_time = pointdatems;
                }
                if (count > 0) {
                  yaxis_array[yaxis_key].gridlinewidth = 0;
                }
                let guideLines: any = [];
                guideLines.push({
                  value: this.dune_crest - this.relativeOffset,
                  color:
                    surgeService.appConfig.plotColors["dune_crest_guide_line"],
                  width: 2,
                  label: {
                    text: "Overwash - Inundation"
                  }
                });
                guideLines.push({
                  value: this.dune_base - this.relativeOffset,
                  color:
                    surgeService.appConfig.plotColors["dune_base_guide_line"],
                  dashStyle: "longdash",
                  width: 2,
                  label: {
                    text: "Erosion"
                  }
                });
                guideLines.push({
                  value: this.tideMLLW - this.relativeOffset,
                  color: surgeService.appConfig.plotColors["mllw_guide_line"],
                  dashStyle: "shortdash",
                  width: 2,
                  label: {
                    text: "MLLW"
                  }
                });
                guideLines.push({
                  value: this.tideMHHW - this.relativeOffset,
                  color: surgeService.appConfig.plotColors["mhhw_guide_line"],
                  dashStyle: "shortdash",
                  width: 2,
                  label: {
                    text: "MHHW"
                  }
                });
                switch (this.relativeTo) {
                  case "MSL":
                  case "NAVD88":
                    guideLines.push({
                      value: this.tideMSL - this.relativeOffset,
                      color:
                        surgeService.appConfig.plotColors["msl_guide_line"],
                      dashStyle: "shortdash",
                      width: 2,
                      label: {
                        text: this.relativeTo
                      }
                    });
                    break;
                }

                yaxis_array[yaxis_key].plotLines = guideLines;
                toggle_opposite = !toggle_opposite;
                count++;
              }
            } // end if sf_key is zero ( ie the first one)
            switch (sp_key) {
              case "etcwlsfc":
                // adding a range timeseries.
                if (param_time_series_range[sp_key] == undefined) {
                  // create an array to hold data objects
                  param_time_series_range[sp_key] = {};
                  param_time_series_range[sp_key].data = [];
                  param_time_series_range[sp_key].name = sp_key;
                  param_time_series_range[sp_key].uom = "flibits";
                  param_time_series_range[sp_key].display_uom =
                    "flibits display uom";
                }
                if (param_time_series_range[sp_key].data[0] == undefined) {
                  param_time_series_range[sp_key].data[0] = {};
                  param_time_series_range[sp_key].data[0].reading_array = [];
                  // adding a range for this series.
                  let new_series_object_range: any = {};
                  // nothing to do with highcharts It's to match the point data
                  // accumulation array later on.
                  new_series_object_range.sp_key = sp_key;
                  new_series_object_range.data =
                    param_time_series_range[sp_key].data[0].reading_array;
                }
                // -9999.9 is used as no data.
                if (
                  sp[sp_key] != undefined &&
                  (sp[sp_key] > -9999.0 && sp[sp_key] < 900)
                ) {
                  var value = parseFloat(sp[sp_key]);
                  var percent_over = 1 + tide_surge_variability / 100;
                  var percent_under = 1 - tide_surge_variability / 100;
                  var low_range = parseFloat(
                    sprintf(dt_format, percent_under * value)
                  );
                  var high_range = parseFloat(
                    sprintf(dt_format, percent_over * value)
                  );
                  param_time_series_range[sp_key].data[0].reading_array.push([
                    pointdatems,
                    low_range,
                    high_range
                  ]);
                }
                break;
              default:
                break;
            }
            if (param_time_series[sp_key] == undefined) {
              // create an array to hold data objects
              param_time_series[sp_key] = {};
              param_time_series[sp_key].data = [];
              param_time_series[sp_key].name = sp_key;
              param_time_series[sp_key].uom = "flibits";
              param_time_series[sp_key].display_uom = "flibits display uom";
            }
            if (param_time_series[sp_key].data[0] == undefined) {
              param_time_series[sp_key].data[0] = {};
              param_time_series[sp_key].data[0].reading_array = [];
              let new_series_object: any = {};
              // nothing to do with highcharts It's to match the point data
              // accumulation array later on.
              new_series_object.sp_key = sp_key;
              // 5-18-2017 It seems as if this array is no longer staying as
              // a part of the new_series_object !?
              new_series_object.data =
                param_time_series[sp_key].data[0].reading_array;
            }
            // -9999.9 is used as no data.
            if (
              sp[sp_key] != undefined &&
              (sp[sp_key] > -9999.0 && sp[sp_key] < 900)
            ) {
              var value_is = parseFloat(sp[sp_key]);
              switch (sp_key) {
                case "etcwlsfc":
                  param_time_series[sp_key].data[0].reading_array.push([
                    pointdatems,
                    value_is
                  ]);
                  break;
                case "Rhigh":
                  if (
                    rhigh_point_count > 0 &&
                    rhigh_point_count < num_points - 1
                  ) {
                    param_time_series[sp_key].data[0].reading_array.push([
                      pointdatems,
                      value_is
                    ]);
                  }
                  rhigh_point_count++;
                  break;
                default:
                  param_time_series[sp_key].data[0].reading_array.push([
                    pointdatems,
                    value_is
                  ]);
                  break;
              }
            }
          } // end if sp_key is not date
        } // end of stockton parameter
        point_count++;
      } // end of if it's a parameter to use
    } // end of looping
    //
    // new_series_object = {
    //     name: 'mcv',
    //             type: 'scatter',
    //             marker: {
    //         enabled: false
    //     },
    //     visible: false,
    //     data: [chart_max_time,chart_max]
    // }
    // new_series.push( new_series_object );
    // yaxis_array[yaxis_key].min = min_tp;
    yaxis_array[yaxis_key].max = chart_max;
    if (point_count > 3) {
      ret_array["success"] = "yes";
    } else {
      ret_array["success"] =
        "Not enough points were created to complete a chart for " + this.name;
    }
    // var chart_title = "MLLW of " + this.tideMLLW;
    var chart_title =
      surgeService.appConfig.various_titles["surge_tab_chart"] + this.name;
    // create an array without the keys
    var yaxis = [];
    for (var yaxis_keyb in yaxis_array) {
      yaxis.push(yaxis_array[yaxis_keyb]);
    }

    // 5-18-2017 It seems as if this array is no longer staying as
    // a part of the new_series_object !?
    for (var pts_key in param_time_series) {
      // match the sp_key added to the individual series objects with the
      // param_time_series keys and add the array if it is a match.
      for (var nso_key in new_series) {
        if (new_series[nso_key].sp_key == pts_key) {
          new_series[nso_key].data =
            param_time_series[pts_key].data[0].reading_array;
          break;
        }
      }
    }
    // Series with no data are preventing the chart from drawing. Remove them
    // this didn't help I'm removing it.
    // for ( var ns_check_key in new_series ) {
    //   if ( new_series[ns_check_key].data.length == 0 ) {
    //     var int_ns_check_key = parseInt(ns_check_key) ;
    //     new_series.splice(int_ns_check_key, 1) ;
    //   }
    // }
    var chartConfig = {
      options: {
        //navigator: {
        //---adaptToUpdatedData: false,
        //enabled: true
        //}
        series: {
          dataLabels: {
            enabled: true
          }
        }
      },
      //This is the Main Highcharts chart config. Any Highchart options are valid here.
      //will be overriden by values specified below.
      chart: {
        type: "spline",
        // width: 350,
        // Adding this line causes a Highcharts not defined error.
        // animation: Highcharts.svg, // don't animate in old IE
        // marginRight: 100, // hide margin style to render full width - chart display: block in app.scss
        // marginLeft: 100,
        marginBottom: 100,
        ignoreHiddenSeries: false
      },
      legend: {
        enabled: true,
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        x: 0,
        y: 0,
        floating: true,
        borderColor: "#999999",
        // title: { text:"My Legend Here"},
        backgroundColor: "#FFFFFF"
        // backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
      },
      rangeSelector: {
        // selected: 2
        enabled: false
      },
      scrollbar: {
        enabled: false
      },
      navigator: {
        enabled: false
      },
      title: {
        text: chart_title,
        x: -20 //center
      },
      //Whether to use Highstocks instead of Highcharts (optional). Defaults to false.
      // useHighStocks: global_use_highstocks,
      subtitle: {
        // text: this.stocktonPointForecasts.name,
        text: "Displayed relative to " + this.relativeTo,
        x: -20
      },
      xAxis: {
        type: "datetime",
        // min: surgeService.appConfig.getMinDateAllowed().getTime(),
        min: min_xaxis_time,
        max: surgeService.appConfig.getEndDate().getTime(),
        tickInterval:
          surgeService.appConfig.chartTickIntervalsInMinutes * 60 * 1000,
        allowDecimals: true,
        minTickInterval:
          surgeService.appConfig.chartTickIntervalsInMinutes * 60 * 1000,
        ordinal: false
      },
      yAxis: yaxis,
      series: new_series
    };
    ret_array["chartConfig"] = chartConfig;
    ret_array["legendAugmentation"] = this.legendAugmentation();
    return ret_array;
  }
}

class stockton_point {
  dt_format: string;
  date: any;
  relativeOffset: number;
  waveHeight: number;
  wavePeriod: number;
  waveLength: number;
  waveSetup: number = 0;
  obsWaveHeight: number;
  obsWavePeriod: number;
  obsWaveLength: number;
  obsWaveSetup: number = 0;
  etcwlsfc: number;
  elevsfc: number;
  etsrgsfc: number;
  etsurgeplustide: number;
  Rhigh: number = null;
  Rlow: number = null;
  max_value: number = 0;
  max_waterlevel: number = 0;
  min_waterlevel: number = 0;
  etofs_debug_data: any;
  H0L0: number = 0;
  appConfig: any;
  R2: number;

  constructor(
    pointDate: any,
    beachSlope: number,
    duneCrest: number,
    duneBase: number,
    waveHeight: number,
    wavePeriod: number,
    waveLength: number,
    obsWaveHeight: number,
    obsWavePeriod: number,
    obsWaveLength: number,
    etcwlsfc: number,
    elevsfc: number,
    etsrgsfc: number,
    etofs_debug_data: any,
    relativeOffset: number,
    dt_format
  ) {
    this.dt_format = dt_format;

    this.date = new Date(pointDate.getTime());

    this.relativeOffset = relativeOffset;
    this.waveHeight = waveHeight;
    this.wavePeriod = wavePeriod;
    this.waveLength = waveLength;
    this.obsWaveHeight = obsWaveHeight;
    this.obsWavePeriod = obsWavePeriod;
    this.obsWaveLength = obsWaveLength;
    this.etcwlsfc = etcwlsfc - relativeOffset;
    this.elevsfc = elevsfc - relativeOffset;
    this.etsrgsfc = etsrgsfc;
    this.etsurgeplustide = this.elevsfc + this.etsrgsfc;
    this.etofs_debug_data = etofs_debug_data;
    // elevsfc surface ocean surface elevation relative to geoid (tide) [m] "
    // etsrgsfc surface extra tropical storm surge [m] "
    // etcwlsfc surface extra tropical storm surge combined surge and tide [m] "
    // R2 = (0.35 * Bf (H0L0)raised to the 1/2 + [H0L0(0.563Bfsquared + .004)] to the 1/2 alldivided by 2)
    // Bf= Before shore Beach slope
    // H0 Deep water wave height
    // L0 Deep water wave length
    //
    // If wave data is available then do the calculations
    if (this.waveLength > 0) {
      var h0l0 = this.waveLength * waveHeight;
      this.H0L0 = parseFloat(sprintf(this.dt_format, h0l0));
      // Step 1 : 0.35 * Bf (H0L0)raised to the 1/2
      var waveSetup = 0.35 * beachSlope * Math.sqrt(h0l0);
      // step 2 : [H0L0(0.563Bfsquared + .004)] to the 1/2
      var swash =
        Math.sqrt(h0l0 * (0.5638 * beachSlope * beachSlope + 0.004)) / 2;
      var R2 = waveSetup + swash;
      if (this.etcwlsfc > -9999) {
        var surge_and_tide = this.elevsfc + this.etsrgsfc; // this.etcwlsfc ;
        var surge = this.etsrgsfc;
        // Rhigh = tide + surge + R2
        this.Rhigh = parseFloat(sprintf(this.dt_format, surge_and_tide + R2));
        if (this.Rhigh > 100) {
          var temp = "temp";
        }
        // Rlow = surge + wave setup
        // this.Rlow = parseFloat(sprintf(this.dt_format, surge + waveSetup));
        // no Rlow was suppose to include tide!
        this.Rlow = parseFloat(
          sprintf(this.dt_format, surge_and_tide + waveSetup)
        );
        this.waveSetup = parseFloat(sprintf(this.dt_format, waveSetup));
      }
      // format after all the calculations.
      this.R2 = parseFloat(sprintf(this.dt_format, R2));
      this.waveHeight = parseFloat(sprintf(this.dt_format, this.waveHeight));
      this.wavePeriod = parseFloat(sprintf(this.dt_format, this.wavePeriod));
      this.waveLength = parseFloat(sprintf(this.dt_format, this.waveLength));
      if (obsWaveLength > 0) {
        this.obsWaveHeight = parseFloat(
          sprintf(this.dt_format, this.obsWaveHeight)
        );
        this.obsWavePeriod = parseFloat(
          sprintf(this.dt_format, this.obsWavePeriod)
        );
        this.obsWaveLength = parseFloat(
          sprintf(this.dt_format, this.obsWaveLength)
        );
      }
    } else {
      // If observed wave data is available then do the calculations
      if (obsWaveLength > 0) {
        var h0l0 = obsWaveLength * obsWaveHeight;
        this.H0L0 = parseFloat(sprintf(this.dt_format, h0l0));
        // Step 1 : 0.35 * Bf (H0L0)raised to the 1/2
        var waveSetup = 0.35 * beachSlope * Math.sqrt(h0l0);
        // step 2 : [H0L0(0.563Bfsquared + .004)] to the 1/2
        var swash =
          Math.sqrt(h0l0 * (0.5638 * beachSlope * beachSlope + 0.004)) / 2;
        var R2 = waveSetup + swash;
        if (this.etcwlsfc > -9999) {
          var surge_and_tide = this.elevsfc + this.etsrgsfc; // this.etcwlsfc ;
          var surge = this.etsrgsfc;
          // Rhigh = tide + surge + R2
          this.Rhigh = parseFloat(sprintf(this.dt_format, surge_and_tide + R2));
          if (this.Rhigh > 100) {
            var temp = "temp";
          }
          // Rlow = surge + wave setup
          // 10-10-2017 Now it's surge + tide + wave setup.
          this.Rlow = parseFloat(
            sprintf(this.dt_format, surge_and_tide + waveSetup)
          );
          this.obsWaveSetup = parseFloat(sprintf(this.dt_format, waveSetup));
        }
        // format after all the calculations.
        this.R2 = parseFloat(sprintf(this.dt_format, R2));
        this.obsWaveHeight = parseFloat(
          sprintf(this.dt_format, this.obsWaveHeight)
        );
        this.obsWavePeriod = parseFloat(
          sprintf(this.dt_format, this.obsWavePeriod)
        );
        this.obsWaveLength = parseFloat(
          sprintf(this.dt_format, this.obsWaveLength)
        );
      } else {
        var no_data = null;
        this.Rhigh = no_data;
        this.Rlow = no_data;
        this.waveSetup = no_data;
        this.R2 = no_data;
        this.waveHeight = no_data;
        this.wavePeriod = no_data;
        this.waveLength = no_data;
        this.obsWaveHeight = no_data;
        this.obsWavePeriod = no_data;
        this.obsWaveLength = no_data;
      }
    }
    this.etcwlsfc = parseFloat(sprintf(this.dt_format, this.etcwlsfc));
    this.elevsfc = parseFloat(sprintf(this.dt_format, this.elevsfc));
    this.etsrgsfc = parseFloat(sprintf(this.dt_format, this.etsrgsfc));
    this.etsurgeplustide = parseFloat(
      sprintf(this.dt_format, this.etsurgeplustide)
    );

    if (this.waveHeight > this.max_value) {
      this.max_value = this.waveHeight;
    }
    if (this.obsWaveHeight > this.max_value) {
      this.max_value = this.obsWaveHeight;
    }
    if (this.Rhigh < 900 && this.Rhigh > this.max_value) {
      this.max_value = this.Rhigh;
    }
    // save the minimum and maximum waterlevels
    // I need to rename this to max chart value or something!
    if (this.Rhigh < 900 && this.Rhigh > this.max_waterlevel) {
      this.max_waterlevel = this.Rhigh;
    }
    if (this.waveHeight > this.max_waterlevel) {
      this.max_waterlevel = this.waveHeight;
    }
    if (this.Rhigh < 900 && this.Rhigh < this.min_waterlevel) {
      this.min_waterlevel = this.Rhigh;
    }
    // use etsrgsfc incase  waveHeight is zero and Rhigh didn't get calculated.
    if (this.etsrgsfc < 900 && this.etsrgsfc > this.max_value) {
      this.max_value = this.etsrgsfc;
    }
    if (this.etsrgsfc < 900 && this.etsrgsfc > this.max_waterlevel) {
      this.max_waterlevel = this.etsrgsfc;
    }
    if (this.etsrgsfc > -900 && this.etsrgsfc < this.min_waterlevel) {
      this.min_waterlevel = this.etsrgsfc;
    }
    if (this.elevsfc > -900 && this.elevsfc < this.min_waterlevel) {
      this.min_waterlevel = this.elevsfc;
    }
    if (
      this.etsurgeplustide > -900 &&
      this.etsurgeplustide < this.min_waterlevel
    ) {
      this.min_waterlevel = this.etsurgeplustide;
    }
    if (
      this.etsurgeplustide > -900 &&
      this.etsurgeplustide < this.min_waterlevel
    ) {
      this.min_waterlevel = this.etsurgeplustide;
    }
    if (this.min_waterlevel < -100) {
      var temp = "temp";
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/inundation-provider.ts